const routes = [
  {
    id: '1',
    name: '首页',
    icon: 'el-icon-house',
    path: '/Home',
    component: () => import('@/page/home/Home'),
    meta: {
      id: '1',
    },
  },
  {
    id: '1000912',
    path: '/payment/voucher',
    component: () => import('@/page/payment/voucher'),
    name: '付款凭证',
    meta: {
      showOperaManual: true,
      id: '1000912',
    },
  },
  
  {
    id: '159',
    name: '我的会员池',
    icon: 'el-icon-document-copy',
    path: '/Mymemberlist',
    component: () => import('@/page/mymemberlist/Mymemberlist'),
    meta: {
      keepAlive: true,
      showOperaManual: true,
      id: '159',
    },
  },
  {
    id: '100918',
    children: [
      {
        id: '100919',
        path: '/wxworkInfo/record',
        component: () => import('@/page/wxworkInfo/record'),
        meta: {
          id: '100919',
          showOperaManual: true,
          name: '企微信息管理',
        },
      },
      {
        id: '101101',
        path: '/wxworkInfo/labelRecord',
        component: () => import('@/page/wxworkInfo/labelRecord'),
        meta: {
          id: '101101',
          showOperaManual: true,
          name: '标注记录',
        },
      },
      {
        id: '100920',
        path: '/wxworkInfo/customerInformation',
        component: () => import('@/page/wxworkInfo/customerInformation'),
        meta: {
          id: '100920',
          name: '客户信息',
          showOperaManual: true,
          keepAlive: true,
        },
      },
      {
        id: '100960',
        path: '/wxworkInfo/enterpriseEvaluation',
        component: () => import('@/page/wxworkInfo/enterpriseEvaluation'),
        meta: {
          id: '100960',
          name: '企业评价',
          showOperaManual: true,
          keepAlive: true,
        },
      },
      {
        id: '100961',
        path: '/wxworkInfo/customerGroupSending',
        component: () => import('@/page/wxworkInfo/customerGroupSending/list'),
        meta: {
          id: '100961',
          name: '客户群发',
          showOperaManual: true,
          keepAlive: true,
        },
      },
      {
        id: '100962',
        path: '/wxworkInfo/customerGroupSending/add',
        component: () => import('@/page/wxworkInfo/customerGroupSending/add'),
        meta: {
          id: '100962',
          name: '客户群发新增',
          showOperaManual: true,
          keepAlive: true,
        },
      },
      {
        id: '100962',
        path: '/wxworkInfo/customerGroupSending/details/:strItems',
        component: () => import('@/page/wxworkInfo/customerGroupSending/details'),
        meta: {
          id: '100962',
          name: '客户群发详情',
          showOperaManual: true,
          keepAlive: true,
        },
      },
      {
        id: '100965',
        path: '/wxworkInfo/customerMarketing',
        component: () => import('@/page/wxworkInfo/customerMarketing/list'),
        meta: {
          id: '100965',
          name: '客户营销任务',
          showOperaManual: true,
          keepAlive: true,
        },
      },
       {
        id: '100966',
        path: '/wxworkInfo/customerMarketing/add/:strItems',
        component: () => import('@/page/wxworkInfo/customerMarketing/add'),
        meta: {
          id: '100966',
          name: '客户营销任务新增',
          showOperaManual: true,
          keepAlive: true,
        },
      },
      {
        id: '100969',
        path: '/wxworkInfo/marketingDataDashboard',
        component: () => import('@/page/wxworkInfo/marketingDataDashboard'),
        meta: {
          id: '100969',
          name: '营销数据看板',
          showOperaManual: true,
          keepAlive: true,
        },
      },
      {
        id: '100979',
        path: '/wxworkInfo/customerAnalysis',
        component: () => import('@/page/wxworkInfo/dataAnalysis/customerAnalysis'),
        meta: {
          id: '100979',
          name: '客户分析',
          showOperaManual: true,
          keepAlive: true,
        },
      },
      {
        id: '100980',
        path: '/wxworkInfo/conversationAnalysis',
        component: () => import('@/page/wxworkInfo/dataAnalysis/conversationAnalysis'),
        meta: {
          id: '100980',
          name: '会话分析',
          showOperaManual: true,
          keepAlive: true,
        },
      },
       {
        id: '100981',
        path: '/wxworkInfo/customerReport',
        component: () => import('@/page/wxworkInfo/customerReport/customerReport'),
        meta: {
          id: '100981',
          name: '客户报表',
          showOperaManual: true,
          keepAlive: true,
        },
      },
      {
        id: '100930',
        path: '/wxworkInfo/LabelManagement',
        component: () => import('@/page/wxworkInfo/LabelManagement'),
        meta: {
          id: '100930',
          name: '标签管理',
          keepAlive: true,
        },
      },
      {
        id: '101106',
        path: '/wxworkInfo/labelManagementNew',
        component: () => import('@/page/wxworkInfo/labelManagementNew'),
        meta: {
          id: '101106',
          name: '标签管理（新）',
          showOperaManual: true,
          keepAlive: true,
        },
      },
      {
        id: '100970',
        path: '/wxworkInfo/contactPermissionConfiguration',
        component: () => import('@/page/wxworkInfo/contactPermissionConfiguration/list'),
        meta: {
          id: '100970',
          name: '企微客户联系人权限配置',
          showOperaManual: true,
          keepAlive: true,
        },
      },
      {
        id: '100971',
        path: '/wxworkInfo/contactPermissionConfiguration/add',
        component: () => import('@/page/wxworkInfo/contactPermissionConfiguration/add'),
        meta: {
          id: '100971',
          name: '设置企微客户联系人管理权限规则',
          showOperaManual: true,
          keepAlive: true,
        },
      },
      {
        id: '100972',
        path: '/wxworkInfo/contactPermissionConfiguration/details/:strItems',
        component: () => import('@/page/wxworkInfo/contactPermissionConfiguration/details'),
        meta: {
          id: '100972',
          name: '企微客户联系人管理权限规则详情',
          showOperaManual: true,
          keepAlive: true,
        },
      },
      {
        id: '100920',
        path: '/wxworkInfo/weworkAdmin',
        component: () => import('@/page/wxworkInfo/weworkAdmin'),
        meta: {
          id: '100920',
          name: '联系我',
          showOperaManual: true,
          keepAlive: true,
        },
      },
      {
        id: '12000',
        path: '/wxworkInfo/addWeworkAdmin/:strItems',
        component: () => import('@/page/wxworkInfo/addWeworkAdmin'),
        name: '新增联系人',
        hidden: true,
        meta: {
          keepAlive: false,
          hidden: true,
          id: '12000',
        },
      },
      {
        id: '100921',
        path: '/wxworkInfo/customerManagementList',
        component: () => import('@/page/wxworkInfo/customerManagementList/list'),
        meta: {
          id: '100921',
          name: '客户列表',
          showOperaManual: true,
          keepAlive: true,
        },
      },
       {
        id: '100922',
        path: '/wxworkInfo/customerChurn',
        component: () => import('@/page/wxworkInfo/customerChurn'),
        meta: {
          id: '100922',
          name: '客户流失',
          showOperaManual: true,
          keepAlive: true,
        },
      },
       {
        id: '100928',
        path: '/wxworkInfo/conversationArchive/globalSession',
        component: () => import('@/page/wxworkInfo/conversationArchive/globalSession'),
        meta: {
          id: '100928',
          name: '全局会话',
          showOperaManual: true,
          keepAlive: true,
        },
      },
       {
        id: '100929',
        path: '/wxworkInfo/conversationArchive/employeeConversation',
        component: () => import('@/page/wxworkInfo/conversationArchive/employeeConversation'),
        meta: {
          id: '100929',
          name: '员工会话',
          showOperaManual: true,
          keepAlive: true,
        },
      },
       {
        id: '100936',
        path: '/wxworkInfo/conversationArchive/customerSession',
        component: () => import('@/page/wxworkInfo/conversationArchive/customerSession'),
        meta: {
          id: '100936',
          name: '客户会话',
          showOperaManual: true,
          keepAlive: true,
        },
      },
    ],
  },
  {
    id: '100402',
    children: [
      {
        id: '100403',
        name: '社会保险',
        path: '/social/insurance',
        component: () => import('@/page/social/insurance'),
        mmeta: {
          keepAlive: true,
          id: '100403',
        },
      },
    ],
  },
  {
    id: '100306',
    children: [
      {
        id: '100307',
        name: '坐席绑定',
        path: '/AI_outbound/seat_binding',
        component: () => import('@/page/AIOutbound/seat_binding'),
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '100307',
        },
      },
      {
        id: '100308',
        name: '坐席分配',
        path: '/AI_outbound/seat_allocation',
        component: () => import('@/page/AIOutbound/seat_allocation'),
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '100308',
        },
      },
      {
        id: '100309',
        name: '通话流水',
        path: '/AI_outbound/telephone_flow',
        component: () => import('@/page/AIOutbound/telephone_flow'),
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '100309',
        },
      },
      {
        id: '100310',
        name: '转化情况',
        path: '/AI_outbound/trnasformation_situation',
        component: () => import('@/page/AIOutbound/trnasformation_situation'),
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '100310',
        },
      },
    ],
  },
  {
    id: '100222',
    children: [
      {
        id: '100223',
        name: '师徒配置',
        path: '/master_apprentice/config',
        component:() => import('@/page/master_apprentice/config'),
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '100223',
        },
      },
      {
        id: '100224',
        name: '师徒记录',
        path: '/master_apprentice/record',
        component: () => import('@/page/master_apprentice/record'),
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '100224',
        },
      },
      {
        id: '100225',
        name: '师徒周报',
        path: '/master_apprentice/weekly_report',
        component: () => import('@/page/master_apprentice/weekly_report'),
        meta: {
          showOperaManual: true,
        },
      },
    ],
  },
  {
    id: '100128',
    icon: 'el-icon-monitor',
    children: [
      {
        id: '100129',
        name: '资产列表',
        component: () => import('@/page/assets/list'),
        path: '/assets/list',
        meta: {
          showOperaManual: true,
          id: '100129',
        },
      },
      {
        id: '100130',
        name: '资产词典',
        component: () => import('@/page/assets/dictionaries'),
        path: '/assets/dictionaries',
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '100130',
        },
      },
      {
        id: '100131',
        name: '领取记录',
        component: () => import('@/page/assets/record'),
        path: '/assets/record',
        meta: {
          showOperaManual: true,
          keepAlive: true,
          id: '100131',
        },
      },
      {
        id: '100132',
        name: '我的资产',
        component: () => import('@/page/assets/mine'),
        path: '/assets/mine',
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '100132',
        },
      },
    ],
  },
  {
    id: '131109',
    name: '培训xxx',
    icon: 'el-icon-monitor',
    children: [
      {
        id: '131110',
        path: '/study/classify',
        icon: 'el-icon-monitor',
        name: '资料分类',
        component: () => import('@/page/study/classify'),
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '131110',
        },
      },
      {
        id: '131111',
        name: '资料列表',
        icon: 'el-icon-monitor',
        path: '/study/platform',
        component: () => import('@/page/study/platform'),
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '131111',
        },
      },
    ],
  },
  {
    id: '101115',
    name: '宿舍上传',
    children: [
      {
        id: '101116',
        path: '/dormitory/uploadList',
        component: () => import('@/page/dormitory/upload_list'),
        name: '宿舍上传列表',
        hidden: true,
        meta: {
          showOperaManual: true,
          keepAlive: true,
          name: '宿舍上传列表',
          id: '101116',
        },
      },
      {
        id: '101117',
        path: '/dormitory/upload',
        component: () => import('@/page/dormitory/upload'),
        name: '宿舍上传新增',
        hidden: true,
        meta: {
          keepAlive: false,
          name: '宿舍上传新增',
          id: '101117',
        },
      },
    ],
  },
  // 供应商中心
  {
    id: '172',
    icon: 'el-icon-house',
    path: '/SupplierCenter',
    children: [
      {
        id: '172',
        path: '/SupplierCenter',
        component: () => import('@/page/supplierCenter/SupplierCenter'),
        name: '供应商中心',
        meta: {
          showOperaManual: true,
          keepAlive: true,
          id: '172',
        },
      },
      {
        id: '1794',
        name: '明细',
        icon: 'el-icon-document-copy',
        path: '/supplierDet/:strItems',
        component: () => import('@/page/supplierCenter/supplierDet'),
        meta: {
          keepAlive: true,
          id: '1794',
        },
      },
    ],
  },
  {
    id: '2',
    name: '集团管理',
    icon: 'el-icon-setting',
    path: '/groupmanagement',
    children: [
      {
        id: '21',
        path: '/groupmanagement/Dtaff',
        component: () => import('@/page/groupmanagement/staff/Dtaff'),
        name: '内部员工管理',
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '21',
        },
      },
      {
        id: '22',
        path: '/groupmanagement/Structure',
        component: () => import('@/page/groupmanagement/structure/Structure'),
        name: '部门架构',
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '22',
        },
      },
      {
        id: '23',
        path: '/groupmanagement/Part',
        component: () => import('@/page/groupmanagement/part/Part'),
        name: '角色',
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '23',
        },
      },
      {
        id: '28',
        path: '/groupmanagement/addpart/:strItems',
        component: () => import('@/page/groupmanagement/part/addpart'),
        name: '角色新增',
        hidden: true,
        meta: {
          hidden: true,
          keepAlive: false,
          id: '28',
        },
      },
      {
        id: '24',
        path: '/groupmanagement/Log',
        component: () => import('@/page/groupmanagement/log/Log'),
        name: '操作日志',
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '24',
        },
      },
      {
        id: '25',
        path: '/groupmanagement/Menu',
        component: () => import('@/page/groupmanagement/menu/Menu'),
        name: '菜单',
        meta: {
          keepAlive: false,
          showOperaManual: true,
          id: '25',
        },
      },
      {
        id: '29',
        path: '/groupmanagement/addMenus/:strItems',
        component: () => import('@/page/groupmanagement/menu/addMenus'),
        name: '菜单新增',
        hidden: true,
        meta: {
          hidden: true,
          keepAlive: false,
          id: '29',
        },
      },
      {
        id: '26',
        path: '/groupmanagement/Author',
        component: () => import('@/page/groupmanagement/author/Author'),
        name: '权限',
        meta: {
          keepAlive: false,
          showOperaManual: true,
          id: '26',
        },
      },
      {
        id: '261',
        path: '/groupmanagement/addAuthors/:strItems',
        component: () => import('@/page/groupmanagement/author/addAuthors'),
        name: '权限新增',
        hidden: true,
        meta: {
          hidden: true,
          keepAlive: false,
          id: '261',
        },
      },
      {
        id: '27',
        path: '/groupmanagement/Postes',
        component: () => import('@/page/groupmanagement/postes/Postes'),
        name: '岗位',
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '27',
        },
      },
    ],
  },
  {
    id: '3',
    name: '企业订单管理',
    icon: 'el-icon-document',
    path: '/ordermanagement',
    children: [
      {
        id: '31',
        path: '/ordermanagement/Order',
        component: () => import('@/page/ordermanagement/order/Order'),
        name: '企业管理',
        meta: {
          showOperaManual: true,
          keepAlive: true,
          id: '31',
        },
      },
      {
        id: '1999',
        path: '/ordermanagement/MemberTraining',
        component: () => import('@/page/ordermanagement/MemberTraining/MemberTraining'),
        name: '会员入职指引',
        meta: {
          name: '会员入职指引',
          keepAlive: true,
          showOperaManual: true,
          id: '1999',
        },
      },
      {
        id: '209',
        path: '/ordermanagement/alipaySynchronization',
        component: () =>import('@/page/ordermanagement/alipaySynchronization/alipaySynchronization'),
        name: '支付宝同步',
        hidden: true,
        meta: {
          name: '支付宝同步',
          showOperaManual: true,
          keepAlive: true,
          id: '209',
        },
      },
      {
        id: '20002',
        path: '/ordermanagement/addAlipaySynchronization/:strItems',
        component: () => import('@/page/ordermanagement/alipaySynchronization/addAlipaySynchronization'),
        name: '支付宝同步新增',
        hidden: true,
        meta: {
          keepAlive: false,
          id: '20002',
        },
      },
      {
        id: '20008',
        path: '/ordermanagement/details/:strItems',
        component: () => import('@/page/ordermanagement/alipaySynchronization/details'),
        name: '支付宝同步详情',
        hidden: true,
        meta: {
          keepAlive: false,
          id: '20008',
        },
      },
      {
        id: '10007',
        path: '/ordermanagement/enterpriseBanner',
        component: () => import('@/page/ordermanagement/addbusiness/enterpriseBanner'),
        name: '企业轮播图',
        meta: {
          name: '企业轮播图',
          keepAlive: true,
          showOperaManual: true,
          id: '10007',
        },
      },
      {
        id: '32',
        path: '/ordermanagement/Addbusiness/:strItem',
        component: () => import('@/page/ordermanagement/addbusiness/Addbusiness'),
        name: '企业管理新增',
        hidden: true,
        meta: {
          hidden: true,
          keepAlive: false,
          id: '32',
        },
      },
      {
        id: '33',
        path: '/ordermanagement/Management',
        component: () => import('@/page/ordermanagement/management/Management'),
        name: '订单管理',
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '33',
        },
      },
      {
        id: '10006',
        path: '/ordermanagement/management/poster',
        component: () => import('@/page/ordermanagement/management/poster'),
        name: '订单海报',
        hidden: true,
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '10006',
        },
      },
      {
        id: '34',
        path: '/ordermanagement/Addmanagement/:strItem',
        component: () => import('@/page/ordermanagement/addmanagement/Addmanagement'),
        name: '订单管理新增',
        hidden: true,
        meta: {
          hidden: true,
          keepAlive: false,
          id: '34',
        },
      },
      {
        id: '35',
        path: '/ordermanagement/Subscribe',
        component: () => import('@/page/ordermanagement/subscribe/Subscribe'),
        name: '校园专区预约',
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '33',
        },
      },
      {
        id: '36',
        path: '/ordermanagement/Addsubs',
        component: () => import('@/page/ordermanagement/subscribe/addsubs'),
        name: '校园专区预约新增',
        hidden: true,
        meta: {
          hidden: true,
          keepAlive: false,
          id: '36',
        },
      },
      {
        id: '37',
        path: '/ordermanagement/orderlist',
        component: () => import('@/page/ordermanagement/orderlist/orderlist'),
        name: '订单统计列表',
        hidden: true,
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '37',
        },
      },
      {
        id: '37',
        path: '/ordermanagement/renew',
        component: () => import('@/page/ordermanagement/renew/renew'),
        name: '订单续签',
        hidden: true,
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '37',
        },
      },
      {
        id: '38',
        path: '/ordermanagement/addrenew/:strItems',
        component: () => import('@/page/ordermanagement/renew/addrenew'),
        name: '订单续签新增',
        hidden: true,
        meta: {
          keepAlive: false,
          hidden: true,
          id: '38',
        },
      },
      {
        id: '38',
        path: '/ordermanagement/marketing',
        component: () => import('@/page/ordermanagement/market/marketing'),
        name: '优质名企专区',
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '38',
        },
      },
      {
        id: '34',
        path: '/ordermanagement/Addmarket/:strItem',
        component: () => import('@/page/ordermanagement/market/Addmarket'),
        name: '优质名企专区新增',
        hidden: true,
        meta: {
          hidden: true,
          keepAlive: false,
          id: '34',
        },
      },
      {
        id: '201',
        path: '/ordermanagement/internal',
        component: () => import('@/page/ordermanagement/internal/Subscribe'),
        name: '内部招聘',
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '201',
        },
      },
      {
        id: '20001',
        path: '/enterpriseInviteConfig/list',
        component: () => import('@/page/enterprise_invite_config/list'),
        name: '企业推荐配置',
        meta: {
          name: '企业推荐配置',
          showOperaManual: true,
          id: '20001',
        },
      },
      {
        id: '20002',
        path: '/enterpriseInviteConfig/addOrEdit/:strItems',
        component: () => import('@/page/enterprise_invite_config/addOrEdit'),
        name: '企业推荐配置新增',
        hidden: true,
        meta: {
          keepAlive: false,
          id: '20002',
        },
      },
      {
        id: '20003',
        path: '/ordermanagement/contractPreview',
        component: () => import('@/page/ordermanagement/contract/preview'),
        name: '订单合同审核',
        meta: {
          name: '订单合同审核',
          keepAlive: false,
          showOperaManual: true,
          id: '20003',
        },
      },
      {
        id: '202',
        path: '/ordermanagement/addinternal',
        component: () => import('@/page/ordermanagement/internal/addsubs'),
        name: '内部招聘新增',
        hidden: true,
        meta: {
          hidden: true,
          keepAlive: false,
          id: '202',
        },
      },
    ],
  },
  {
    id: '4',
    name: '小程序管理',
    icon: 'el-icon-mobile',
    path: '/wechat',
    children: [
      {
        id: '41',
        path: '/wechat/Wechatuser',
        component: () => import('@/page/wechat/wechatuser/Wechatuser'),
        name: '微信用户',
        meta: {
          showOperaManual: true,
          keepAlive: true,
          id: '41',
        },
      },
      {
        id: '42',
        path: '/wechat/Reportlist',
        component: () => import('@/page/wechat/reportlist/Reportlist'),
        name: '报名名单',
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '42',
        },
      },
      {
        id: '43',
        path: '/wechat/Slideshow',
        component: () => import('@/page/wechat/slideshow/Slideshow'),
        name: '轮播图',
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '43',
        },
      },
      {
        id: '44',
        path: '/wechat/Addslideshow/:strItem',
        component: () => import('@/page/wechat/slideshow/Addslideshow'),
        name: '轮播图新增',
        hidden: true,
        meta: {
          hidden: true,
          keepAlive: false,
          id: '44',
        },
      },
      {
        id: '45',
        path: '/wechat/About',
        component: () => import('@/page/wechat/about/About'),
        name: '关于我们',
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '45',
        },
      },
      {
        id: '46',
        path: '/wechat/Information',
        component: () => import('@/page/wechat/information/Information'),
        name: '信息推送管理',
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '46',
        },
      },
      {
        id: '47',
        path: '/wechat/Inforpush/:id',
        component: () => import('@/page/wechat/slideshow/Inforpush'),
        name: '信息推送新增',
        hidden: true,
        meta: {
          hidden: true,
          keepAlive: false,
          id: '47',
        },
      },
      {
        id: '48',
        path: '/wechat/Service',
        component: () => import('@/page/wechat/service/Service'),
        name: '首页客服展示',
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '48',
        },
      },
      {
        id: '49',
        path: '/wechat/addservice/:id',
        component: () => import('@/page/wechat/service/addservice'),
        name: '首页客服展示新增',
        hidden: true,
        meta: {
          hidden: true,
          keepAlive: false,
          id: '49',
        },
      },
      {
        id: '50',
        path: '/wechat/Doorpub',
        component: () => import('@/page/wechat/doorpub/Doorpub'),
        name: '门店公示',
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '50',
        },
      },
      {
        id: '51',
        path: '/wechat/adddoorpub/:id',
        component: () => import('@/page/wechat/doorpub/adddoorpub'),
        name: '门店公示新增',
        hidden: true,
        meta: {
          hidden: true,
          keepAlive: false,
          id: '51',
        },
      },
      {
        id: '52',
        path: '/wechat/video/:id',
        component: () => import('@/page/wechat/video/video'),
        name: '视频号新增',
        meta: {
          hidden: true,
          keepAlive: false,
          id: '52',
        },
      },
      {
        id: '53',
        path: '/wechat/videolist',
        component: () => import('@/page/wechat/video/videolist'),
        name: '视频号',
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '53',
        },
      },
    ],
  },
  {
    id: '6',
    name: '名单管理',
    icon: 'el-icon-news',
    path: '/listmanagement',
    children: [
      {
        id: '61',
        path: '/listmanagement/Facial',
        component: () => import('@/page/listmanagement/facial/Facial'),
        name: '面试名单',
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '61',
        },
      },
      {
        id: '10251121',
        path: '/listmanagement/training',
        component: () => import('@/page/listmanagement/training/training'),
        name: '培训名单',
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '10251121',
        },
      },
      {
        id: '62',
        path: '/listmanagement/Zaizhi',
        component: () => import('@/page/listmanagement/zaizhi/Zaizhi'),
        name: '在离职名单',
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '62',
        },
      },
      {
        id: '63',
        path: '/listmanagement/Uploadliz',
        component: () => import('@/page/listmanagement/uploadliz/Uploadliz'),
        name: '上传在离职名单',
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '63',
        },
      },
      {
        id: '101309',
        path: '/listmanagement/uploadInterviewRoll',
        component: () => import('@/page/listmanagement/uploadInterview/Roll'),
        name: '上传面试名单',
        meta: {
          name: '上传面试名单',
          keepAlive: true,
          showOperaManual: true,
          id: '101309',
        },
      },
      {
        id: '101310',
        path: '/listmanagement/uploadInterviewRollAdd',
        component: () => import('@/page/listmanagement/uploadInterview/Adduploadliz'),
        name: '上传面试名单新增',
        meta: {
          name: '上传面试名单新增',
          keepAlive: true,
          id: '101310',
        },
      },
      {
        id: '64',
        path: '/listmanagement/Rosters',
        component: () => import('@/page/listmanagement/rosters/Rosters'),
        name: '花名册',
        meta: {
          keepAlive: false,
          showOperaManual: true,
          id: '64',
        },
      },
      {
        id: '65',
        path: '/listmanagement/Blacklist',
        component: () => import('@/page/listmanagement/blacklist/Blacklist'),
        name: '特殊名单',
        meta: {
          showOperaManual: true,
          keepAlive: true,
          id: '65',
        },
      },
      {
        id: '66',
        path: '/listmanagement/Addblack/:strItems',
        component: () => import('@/page/listmanagement/blacklist/Addblack'),
        name: '特殊名单新增',
        hidden: true,
        meta: {
          hidden: true,
          keepAlive: false,
          id: '66',
        },
      },
      {
        id: '72',
        path: '/listmanagement/Blacklistname',
        component: () => import('@/page/listmanagement/blacklistname/Blacklistname'),
        name: '活动特殊名单',
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '73',
        },
      },
      {
        id: '73',
        path: '/listmanagement/Addblackname/:strItems',
        component: () => import('@/page/listmanagement/blacklistname/Addblackname'),
        name: '活动特殊名单新增',
        meta: {
          keepAlive: false,
          id: '73',
        },
      },
      {
        id: '67',
        path: '/listmanagement/Adduploadliz',
        component: () => import('@/page/listmanagement/uploadliz/Adduploadliz'),
        name: '上传在职离职名单新增',
        hidden: true,
        meta: {
          hidden: true,
          keepAlive: false,
          id: '67',
        },
      },
      {
        id: '68',
        name: '补录',
        // icon: 'el-icon-edit',
        path: '/listmanagement/Supplement',
        component: () => import('@/page/listmanagement/supplement/Supplement'),
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '68',
        },
      },
      {
        id: '69',
        name: '推荐活动人员名单',
        // icon: 'el-icon-edit',
        path: '/listmanagement/Eventslist',
        component: () => import('@/page/listmanagement/eventslist/Eventslist'),
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '69',
        },
      },
      {
        id: '10009',
        name: '推荐报名人员名单',
        path: '/recommend/activity',
        component: () => import('@/page/recommend/activity'),
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '10009',
        },
      },
      {
        id: '10027',
        name: '拼团活动',
        path: '/activity/group',
        component: () => import('@/page/activity/group'),
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '10027',
        },
      },
      {
        id: '70',
        name: '到店人员',
        // icon: 'el-icon-edit',
        path: '/listmanagement/Arrstore',
        component: () => import('@/page/listmanagement/arrstore/Arrstore'),
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '70',
        },
      },

      {
        id: '10250211',
        path: '/collective/registration',
        name: '集合登记名单',
        component: () => import('@/page/collective/registration'),
        meta: {
          keepAlive: false,
          showOperaManual: true,
          id: '10250211',
        },
      },
      {
        id: '71',
        name: '邀请注册名单',
        // icon: 'el-icon-edit',
        path: '/listmanagement/showstore',
        component: () => import('@/page/listmanagement/showstore/Showstore'),
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '71',
        },
      },
      {
        id: '711',
        name: '会员留资',
        // icon: 'el-icon-edit',
        path: '/listmanagement/memberRetention',
        component: () => import('@/page/listmanagement/memberRetention/memberRetention'),
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '711',
        },
      }, 
      {
        id: '7111',
        name: '技工名单',
        // icon: 'el-icon-edit',
        path: '/skilledWorkersList',
        component: () => import('@/page/listmanagement/skilledWorkersList/skilledWorkersList'),
        meta: {
          keepAlive: false,
          showOperaManual: true,
          id: '7111',
        },
      },
      {
        id: '7112',
        name: '导入技工跟进信息',
        // icon: 'el-icon-edit',
        path: '/skilledWorkFile',
        component: () => import('@/page/listmanagement/skilledWorkersList/skilledWorkFile'),
        meta: {
          keepAlive: false,
          showOperaManual: true,
          id: '7112',
        },
      },
      {
        id: '7113',
        name: '技工会员池',
        // icon: 'el-icon-edit',
        path: '/technicianMembershipPool',
        component: () => import('@/page/listmanagement/technicianMembershipPool/list'),
        meta: {
          keepAlive: false,
          showOperaManual: true,
          id: '7113',
        },
      },
      {
        id: '200',
        name: '会员合同',
        // icon: 'el-icon-edit',
        path: '/applets_contract/list',
        component: () => import('@/page/applets_contract/list'),
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '200',
        },
      },
      {
        id: '100118',
        name: '大额借支',
        // icon: 'el-icon-edit',
        path: '/large_borrow',
        component: () => import('@/page/applets_contract/large/borrow'),
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '100118',
        },
      },
      {
        id: '10999',
        name: '腾讯电子签',
        // icon: 'el-icon-edit',
        path: '/tencent_ele',
        component: () => import('@/page/tencent_ele/tencent_ele'),
        children: [
          {
            id: '10998',
            name: '已签署名单',
            path: '/tencent_ele/tag',
            component: () => import('@/page/tencent_ele/tag'),
            meta: {
              keepAlive: true,
              showOperaManual: true,
              id: '10998',
            },
          },
          {
            id: '10997',
            name: '未签署名单',
            path: '/tencent_ele/no_tag',
            component: () => import('@/page/tencent_ele/no_tag'),
            meta: {
              keepAlive: true,
              showOperaManual: true,
              id: '10997',
            },
          },
        ],
      },
      {
        id: '101125',
        name: '打卡奖励',
        path: '/checkInRewards',
        component: () => import('@/page/rewards/checkIn'),
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '101125',
        },
      },
      {
        id: '101129',
        name: '打卡奖励奖励详情',
        path: '/checkInAmtRewardsDetail',
        component: () => import('@/page/rewards/checkInAmtDetail'),
        hidden: true,
        meta: {
          hidden: true,
          keepAlive: true,
          id: '101129',
        },
      },
      {
        id: '101126',
        name: '打卡奖励名单详情',
        path: '/checkInRewardsDetail',
        component: () => import('@/page/rewards/checkInDetail'),
        hidden: true,
        meta: {
          hidden: true,
          keepAlive: true,
          id: '101126',
        },
      },
      {
        id: '101204',
        name: '打卡奖励总表',
        path: '/checkInSummaryTable',
        component: () => import('@/page/rewards/checkInSummaryTable'),
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '101204',
        },
      },
      {
        id: '101127',
        name: '报到奖励',
        path: '/reportRewards',
        component: () => import('@/page/rewards/report'),
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '101127',
        },
      },
      {
        id: '101128',
        name: '报到奖励名单详情',
        path: '/reportRewardsDetail',
        component: () => import('@/page/rewards/reportDetail'),
        hidden: true,
        meta: {
          hidden: true,
          keepAlive: true,
          id: '101128',
        },
      },
      {
        id: '101130',
        name: '报到奖励奖励详情',
        path: '/reportAmtRewardsDetail',
        component: () => import('@/page/rewards/reportAmtDetail'),
        hidden: true,
        meta: {
          hidden: true,
          keepAlive: true,
          id: '101130',
        },
      },
      {
        id: '101205',
        name: '报到奖励总表',
        path: '/reportSummaryTable',
        component: () => import('@/page/rewards/reportSummaryTable'),
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '101205',
        },
      },
      {
        id: '101129',
        name: '上传',
        path: '/rewardsUpload',
        component: () => import('@/page/rewards/upload'),
        hidden: true,
        meta: {
          hidden: true,
          keepAlive: true,
          id: '101129',
        },
      },
    ],
  },
  {
    id: '370',
    path: '/ordermanagement/Mysubscribe',
    icon: 'el-icon-timer',
    component: () => import('@/page/ordermanagement/mysubscribe/Mysubscribe'),
    name: '我的预约年后报名',
    meta: {
      keepAlive: true,
      id: '370',
    },
  },
  {
    id: '372',
    path: '/ordermanagement/yearSignUp',
    icon: 'el-icon-timer',
    component: () => import('@/page/ordermanagement/yearSignUp/yearSignUp'),
    name: '年后预约',
    meta: {
      keepAlive: true,
      showOperaManual: true,
      id: '372',
    },
  },
  {
    id: '371',
    path: '/ordermanagement/MyOursSign',
    icon: 'el-icon-timer',
    component: () => import('@/page/ordermanagement/OursJobsSign/MyOursJobsSign'),
    name: '内部招聘名单',
    meta: {
      keepAlive: true,
      showOperaManual: true,
      id: '371',
    },
  },
  {
    id: '7',
    name: '门店管理',
    icon: 'el-icon-office-building',
    path: '/shopmana',
    children: [
      {
        id: '100312',
        path: '/shopmana/dailyStoreData',
        component: () => import('@/page/shopmana/dailyStoreModel/dailyStoreData'),
        name: '每日门店数据',
        meta: {
          id: '100312',
          keepAlive: true,
          showOperaManual: true,
          name: '每日门店数据',
        },
      },
      {
        id: '100313',
        path: '/shopmana/dailyOperaData',
        component: () => import('@/page/shopmana/dailyStoreModel/dailyOperaData'),
        name: '每日运营数据',
        meta: {
          id: '100313',
          keepAlive: true,
          showOperaManual: true,
          name: '每日运营数据',
        },
      },
      /**------------------------------------ */
      {
        id: '71',
        path: '/shopmana/creatshoper',
        component: () => import('@/page/shopmana/creatshoper'),
        name: '创建门店&店长管理',
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '71',
        },
      },
      {
        id: '72',
        path: '/shopmana/addcreatshoper/:strItems',
        component: () => import('@/page/shopmana/addcreatshoper'),
        name: '创建门店&店长管理新增',
        hidden: true,
        meta: {
          hidden: true,
          keepAlive: false,
          id: '72',
        },
      },
      /**------------------------------------ */
      {
        id: '73',
        path: '/shopmana/storeclerk',
        component: () => import('@/page/shopmana/storeclerk'),
        name: '门店经纪人',
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '73',
        },
      },
      {
        id: '74',
        path: '/shopmana/addstoreclerk/:strItems',
        component: () => import('@/page/shopmana/addstoreclerk'),
        name: '门店经纪人新增',
        hidden: true,
        meta: {
          hidden: true,
          keepAlive: false,
          id: '74',
        },
      },
      /**------------------------------------ */
      {
        id: '75',
        path: '/shopmana/storearea',
        component: () => import('@/page/shopmana/storearea'),
        name: '门店区域',
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '75',
        },
      },
      {
        id: '76',
        path: '/shopmana/addstorearea/:strItems',
        component: () => import('@/page/shopmana/addstorearea'),
        name: '门店区域新增',
        hidden: true,
        meta: {
          hidden: true,
          keepAlive: false,
          id: '76',
        },
      },
      {
        id: '77',
        path: '/shopmana/storegroup',
        component: () => import('@/page/shopmana/storegroup'),
        name: '门店分组',
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '77',
        },
      },
      {
        id: '78',
        path: '/shopmana/addstoregroup/:strItems',
        component: () => import('@/page/shopmana/addstoregroup'),
        name: '门店分组新增',
        hidden: true,
        meta: {
          hidden: true,
          keepAlive: false,
          id: '78',
        },
      },
      
      {
        id: '10031',
        path: '/interior/activityConfig',
        component: () => import('@/page/interior/activityConfig'),
        name: '活动配置',
        meta: {
          id: '10031',
          showOperaManual: true,
          keepAlive: true,
        },
      },
      {
        id: '10020',
        path: '/shopmana/configList',
        component: () => import('@/page/shopmana/configList/configList'),
        name: '内部配置',
        meta: {
          id: '10020',
          showOperaManual: true,
          keepAlive: true,
        },
      },
      {
        id: '101119',
        path: '/sceneTips',
        component: () => import('@/page/sceneTips/sceneTips'),
        meta: {
          name: '场景配置',
          id: '101119',
          showOperaManual: true,
          keepAlive: true,
        },
      },
      {
        id: '100000',
        path: '/system/NFCApplication',
        component: () => import('@/page/system/NFCApplication'),
        name: 'nfc应用',
        meta: {
          id: '100000',
          showOperaManual: true,
          keepAlive: true,
        },
      },
      {
        id: '100051',
        path: '/system/brokerBan',
        component: () => import('@/page/system/brokerBan'),
        name: '账号封禁',
        meta: {
          id: '100051',
          showOperaManual: true,
          keepAlive: true,
        },
      },
      {
        id: '100001',
        path: '/system/NFCApplicationdetails/:strItems',
        component: () => import('@/page/system/NFCApplicationdetails'),
        name: 'nfc用户',
        hidden: false,
        meta: {
          hidden: false,
          keepAlive: false,
          id: '100001',
        },
      },
         {
        id: '1000010',
        path: '/system/decodeWatermark',
        component: () => import('@/page/system/decodeWatermark'),
        name: '解码水印',
        hidden: false,
        meta: {
          hidden: false,
          keepAlive: false,
          id: '1000010',
        },
      },
      {
        id: '10013',
        path: '/shopmana/brokerPerformance',
        component: () => import('@/page/shopmana/brokerPerformance/brokerPerformance'),
        name: '经纪人绩效',
        hidden: true,
        meta: {
          keepAlive: false,
          showOperaManual: true,
          id: '10013',
        },
      },
      {
        id: '10012',
        path: '/shopmana/performance',
        component: () => import('@/page/shopmana/performance/performance'),
        name: '考核表',
        hidden: true,
        meta: {
          keepAlive: false,
          showOperaManual: true,
          id: '10012',
        },
      },
       {
        id: '100009',
        path: '/accessControl/accessControlDevice',
        component: () => import('@/page/system/accessControl/accessControlDevice'),
        name: 'accessControlDevice',
        meta: {
          id: '100009',
          showOperaManual: true,
          keepAlive: true,
        },
      },
       {
        id: '100008',
        path: '/accessControl/accessControlLog',
        component: () => import('@/page/system/accessControl/accessControlLog'),
        name: 'accessControlLog',
        meta: {
          id: '100008',
          showOperaManual: true,
          keepAlive: true,
        },
      },
      {
         id: '799',
        path: '/residentCommission',
        name: '驻厂提成计算',
        component: () => import('@/page/residentCommission/cash_one_data'),
        children: [
           {
            id: '7950',
            path: '/residentCommission/residentCommissionConfig',
            component: () => import('@/page/residentCommission/residentCommissionConfig'),
            name: '提成配置',
            meta: {
              keepAlive: false,
              showOperaManual: true,
              id: '7950',
            },
          },
           {
            id: '7951',
            path: '/residentCommission/cash_one_data',
            component: () => import('@/page/residentCommission/cash_one_data'),
            name: '驻厂提成明细',
            meta: {
              keepAlive: false,
              showOperaManual: true,
              id: '7951',
            },
          },
           {
            id: '7952',
            path: '/residentCommission/ResidentCommissionList',
            component: () => import('@/page/residentCommission/ResidentCommissionList'),
            name: '驻厂提成',
            meta: {
              keepAlive: false,
              showOperaManual: true,
              id: '7952',
            },
          },
           {
            id: '7952',
            path: '/residentCommission/ResidentCommissionListTwo/:id',
            component: () => import('@/page/residentCommission/ResidentCommissionListTwo'),
            name: 'ResidentCommissionListTwo',
            meta: {
              keepAlive: false,
              showOperaManual: true,
              id: '7952',
            },
          },
          {
            id: '7953',
            path: '/residentCommission/ResidentCommissionDetail/:id',
            component: () => import('@/page/residentCommission/ResidentCommissionDetail'),
            name: '驻厂提成明细详情',
            meta: {
              // keepAlive: true,
              showOperaManual: true,
              id: '7953',
            },
          },
           {
            id: '7954',
            path: '/residentCommission/supervisoCommissionList',
            component: () => import('@/page/residentCommission/supervisoCommissionList'),
            name: '主管提成',
            meta: {
              keepAlive: false,
              showOperaManual: true,
              id: '7954',
            },
          },
           {
            id: '7954',
            path: '/residentCommission/supervisoCommissionListTwo/:id',
            component: () => import('@/page/residentCommission/supervisoCommissionListTwo'),
            name: 'supervisoCommissionListTwo',
            meta: {
              keepAlive: false,
              showOperaManual: true,
              id: '7954',
            },
          },
          {
            id: '7955',
            path: '/residentCommission/supervisoCommissionDetail/:id',
            component: () => import('@/page/residentCommission/supervisoCommissionDetail'),
            name: '主管提成明细详情',
            meta: {
              // keepAlive: true,
              showOperaManual: true,
              id: '7955',
            },
          },
           {
            id: '7956',
            path: '/residentCommission/masterCommissionList',
            component: () => import('@/page/residentCommission/masterCommissionList'),
            name: '经理提成',
            meta: {
              keepAlive: false,
              showOperaManual: true,
              id: '7956',
            },
          },
           {
            id: '7956',
            path: '/residentCommission/masterCommissionListTwo/:id',
            component: () => import('@/page/residentCommission/masterCommissionListTwo'),
            name: 'masterCommissionListTwo',
            meta: {
              keepAlive: false,
              showOperaManual: true,
              id: '7956',
            },
          },
          {
            id: '7957',
            path: '/residentCommission/masterCommissionDetail/:id',
            component: () => import('@/page/residentCommission/masterCommissionDetail'),
            name: '经理提成明细详情',
            meta: {
              // keepAlive: true,
              showOperaManual: true,
              id: '7957',
            },
          },
            {
            id: '7958',
            path: '/residentCommission/operationLog',
            component: () => import('@/page/residentCommission/operationLog'),
            name: 'OperationLog',
            meta: {
              keepAlive: false,
              showOperaManual: true,
              id: '7958',
            },
          },
        ]
      },
      {
        id: '79',
        path: '/shopmana/commissions',
        name: '提成计算',
        component: () => import('@/page/commissions'),
        children: [
          {
            id: '10241206',
            path: '/commissions/cash_one_data',
            component: () => import('@/page/commissions/cash_one_data'),
            name: '提成明细合并',
            meta: {
              keepAlive: true,
              showOperaManual: true,
              id: '10241206',
            },
          },
          {
            id: '10241203',
            path: '/commissions/cash_region',
            component: () => import('@/page/commissions/cash_region'),
            name: '区域经理提成',
            meta: {
              // keepAlive: true,
              showOperaManual: true,
              id: '10241203',
            },
          },
          {
            id: '10241204',
            path: '/commissions/cash_region_config',
            component: () => import('@/page/commissions/cash_region_config'),
            name: '区域经理配置项',
            meta: {
              keepAlive: true,
              showOperaManual: true,
              id: '10241204',
            },
          },
          {
            id: '10241205',
            path: '/commissions/cash_region_detail/:id',
            component: () => import('@/page/commissions/cash_region_detail'),
            name: '区域经理提成明细',
            meta: {
              // keepAlive: true,
              showOperaManual: true,
              id: '10241205',
            },
          },
          {
            id: '10241205',
            path: '/commissions/cash_region_store_detail/:id',
            component: () => import('@/page/commissions/cash_region_store_detail'),
            name: '区域经理门店汇总',
            meta: {
              keepAlive: true,
              showOperaManual: true,
              id: '10241205',
            },
          },
          {
            id: '10241208',
            path: '/commissions/cash_store',
            component: () => import('@/page/commissions/cash_store'),
            name: '店长提成明细列表',
            meta: {
              // keepAlive: true,
              showOperaManual: true,
              id: '10241208',
            },
          },
          {
            id: '10241209',
            path: '/commissions/cash_store_detail/:id',
            component: () => import('@/page/commissions/cash_store_detail'),
            name: '店长提成明细详情',
            meta: {
              // keepAlive: true,
              showOperaManual: true,
              id: '10241209',
            },
          },
          {
            id: '10241210',
            path: '/commissions/cash_broker',
            component: () => import('@/page/commissions/cash_broker'),
            name: '经纪人提成明细列表',
            meta: {
              // keepAlive: true,
              showOperaManual: true,
              id: '10241210',
            },
          },
          {
            id: '10241211',
            path: '/commissions/cash_broker_detail/:id',
            component: () => import('@/page/commissions/cash_broker_detail'),
            name: '经纪人提成明细详情',
            meta: {
              // keepAlive: true,
              showOperaManual: true,
              id: '10241211',
            },
          },

          {
            id: '792',
            path: '/shopmana/commissions/storecomm',
            component: () => import('@/page/shopmana/commissions/storecomm'),
            name: '门店提成',
            meta: {
              keepAlive: true,
              showOperaManual: true,
              id: '792',
            },
          },
          {
            id: '793',
            path: '/shopmana/commissions/groupcomm',
            component: () => import('@/page/shopmana/commissions/groupcomm'),
            name: '分组提成',
            meta: {
              showOperaManual: true,
              keepAlive: true,
              id: '793',
            },
          },
          {
            id: '794',
            path: '/shopmana/commissions/brokercomm',
            component: () => import('@/page/shopmana/commissions/brokercomm'),
            name: '经纪人提成',
            meta: {
              keepAlive: true,
              showOperaManual: true,
              id: '794',
            },
          },
          {
            id: '795',
            path: '/shopmana/commissions/commdetil',
            component: () => import('@/page/shopmana/commissions/commdetil'),
            name: '提成明细',
            meta: {
              keepAlive: true,
              showOperaManual: true,
              id: '795',
            },
          },
          {
            id: '174',
            path: '/shopmana/commissions/commdetilManager',
            component: () => import('@/page/shopmana/commissions/commdetilManager'),
            name: '店长提成明细',
            meta: {
              showOperaManual: true,
              keepAlive: true,
              id: '174',
            },
          },
        ],
      },
    ],
  },
  {
    id: '9',
    name: '会员简历池',
    icon: 'el-icon-files',
    path: '/Respool',
    component: () => import('@/page/respool/Respool'),
    meta: {
      showOperaManual: true,
      keepAlive: true,
      id: '9',
    },
  },
  {
    id: '91',
    path: '/Problem',
    icon: 'el-icon-help',
    children: [
      {
        id: '911',
        path: '/Problemlist',
        component: () => import('@/page/problem/problem/Problemlist'),
        name: '问题反馈',
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '911',
        },
      },
      {
        id: '10011',
        path: '/anon/feedback',
        component: () => import('@/page/problem/anon/feedback'),
        name: '匿名反馈',
        meta: {
          showOperaManual: true,
          keepAlive: true,
          id: '10011',
        },
      },
      {
        id: '101118',
        path: '/Problemlist/report',
        component: () => import('@/page/problem/problem/report'),
        name: '问题反馈报告',
        meta: {
          showOperaManual: true,
          keepAlive: true,
          id: '101118',
        },
      },
      {
        id: '10018',
        path: '/abnormalOrder/abnormalList',
        component: () => import('@/page/problem/abnormalOrder/abnormalList'),
        name: 'abnormalList',
        meta: {
          showOperaManual: true,
          keepAlive: true,
          id: '10018',
        },
      },
    ],
  },
  {
    id: '116',
    path: '/workolder',
    name: '工单',
    icon: 'el-icon-menu',
    children: [
      {
        id: '1161',
        path: '/Feedbacks',
        component: () => import('@/page/workolder/feedbacks/Feedbacks'),
        name: '工单列表',
        meta: {
          showOperaManual: true,
          keepAlive: true,
          id: '1161',
        },
      },
      {
        id: '1162',
        path: '/Worktype',
        component: () => import('@/page/workolder/worktype/Worktype'),
        name: '工单类型',
        meta: {
          showOperaManual: true,
          keepAlive: true,
          id: '1162',
        },
      },
    ],
  },

  {
    id: '92',
    name: '驻厂管理',
    icon: 'el-icon-discount',
    path: '/Station',
    meta: {
      keepAlive: true,
      showOperaManual: true,
      id: '92',
    },
    component: () => import('@/page/station/Station'),

    // children:[
    // ]
  },
  {
    id: '25101601',
    name: '驻厂组织架构',
    icon: 'el-icon-discount',
    path: '/factory/organizational_structure',
    meta: {
      keepAlive: true,
      showOperaManual: true,
      id: '25101601',
    },
    component: () => import('@/page/factory/organizational_structure'),
  },
  {
    id: '25101801',
    name: '驻厂主管',
    icon: 'el-icon-discount',
    path: '/factory/boss',
    meta: {
      keepAlive: true,
      showOperaManual: true,
      id: '25101801',
    },
    component: () => import('@/page/factory/boss'),
  },
  {
    id: '25101802',
    name: '驻厂区域',
    icon: 'el-icon-discount',
    path: '/factory/area',
    meta: {
      keepAlive: true,
      showOperaManual: true,
      id: '25101802',
    },
    component: () => import('@/page/factory/area'),
  },
  {
    id: '100123',
    name: '评价统计',
    path: '/factory/remark/statistics',
    component: () => import('@/page/factory/statistics'),
    meta: {
      keepAlive: true,
      showOperaManual: true,
      id: '100123',
    },
  },
  {
    id: '100124',
    path: '/factory/remark',
    icon: 'el-icon-monitor',
    name: '驻厂评价',
    component: () => import('@/page/factory/remark'),
    meta: {
      keepAlive: true,
      showOperaManual: true,
      id: '100124',
    },
  },
  {
    id: '100125',
    path: '/factory/remark/statistics/detail/:id',
    icon: 'el-icon-monitor',
    name: '评价统计详情',
    component: () => import('@/page/factory/statistics_detail'),
    meta: {
      keepAlive: true,
      id: '100125',
    },
  },
  {
    id: '93',
    name: '驻厂管理新增',
    icon: 'el-icon-user',
    path: '/Addstation/:strItems',
    hidden: true,
    meta: {
      hidden: true,
      keepAlive: false,
      id: '93',
    },
    component: () => import('@/page/station/addstation'),
  },
  {
    id: '10',
    name: '财务管理',
    icon: 'el-icon-bank-card',
    path: '/financialmanagement',
    children: [
      {
        id: '10001',
        name: '付款申请单',
        path: '/financialmanagement/paymentRequest',
        component: () =>import('@/page/financialmanagement/paymentRequest/paymentRequest'),
        meta: {
          showOperaManual: true,
          keepAlive: true,
          id: '10001',
        },
      },
      {
        id: '10002',
        name: '付款申请单新增',
        icon: 'el-icon-user',
        path: '/financialmanagement/paymentRequest/addOrEditPaymentRequest/:strItems',
        hidden: true,
        meta: {
          keepAlive: false,
          id: '10002',
        },
        component: () =>import('@/page/financialmanagement/paymentRequest/addOrEditPaymentRequest'),
      },
      {
        id: '100021',
        name: '附件工作表',
        icon: 'el-icon-user',
        path: '/financialmanagement/paymentRequest/openAttachments/:strItems',
        hidden: true,
        meta: {
          keepAlive: false,
          id: '100021',
        },
        component: () =>import('@/page/financialmanagement/paymentRequest/openAttachments'),
      },{
        id: '100022',
        name: '工作明细表',
        icon: 'el-icon-user',
        path: '/financialmanagement/paymentRequest/attachmentsDetails/:strItems',
        hidden: true,
        meta: {
          keepAlive: false,
          id: '100022',
        },
        component: () =>import('@/page/financialmanagement/paymentRequest/attachmentsDetails'),
      },
      {
        id: '10003',
        name: '待审核处理列表',
        path: '/financialmanagement/paymentRequest/pengding',
        component: () => import('@/page/financialmanagement/paymentRequest/pending'),
        meta: {
          showOperaManual: true,
          keepAlive: true,
          id: '10003',
        },
      },
      {
        id: '10004',
        name: '已审核处理列表',
        path: '/financialmanagement/paymentRequest/processed',
        component: () => import('@/page/financialmanagement/paymentRequest/processed'),
        meta: {
          showOperaManual: true,
          keepAlive: true,
          id: '10004',
        },
      },
        {
        id: '100040',
        name: '款项类型时间配置',
        path: '/financialmanagement/paymentRequest/paymentTypeTimeConfiguration',
        component: () => import('@/page/financialmanagement/paymentRequest/paymentTypeTimeConfiguration'),
        meta: {
          showOperaManual: true,
          keepAlive: true,
          id: '100040',
        },
      },
      {
        id: '10005',
        name: '审核详情',
        path: '/financialmanagement/paymentRequest/handleDetail',
        component: () => import('@/page/financialmanagement/paymentRequest/handleDetail'),
        hidden: true,
        meta: {
          keepAlive: true,
          id: '10005',
        },
      },
      {
        id: '101',
        path: '/financialmanagement/Obtain',
        component: () => import('@/page/financialmanagement/obtain/Obtain'),
        name: '春节借支申请',
        meta: {
          keepAlive: true,
          id: '101',
        },
      },
      // {
      //     id: '102',
      //     path: '/financialmanagement/Finance',
      //     component: () =>
      //         import ('@/page/financialmanagement/finance/Finance'),
      //     name: '外部提现申请'
      // }, {
      //     id: '1002',
      //     path: '/financialmanagement/commission',
      //     component: () =>
      //         import ('@/page/financialmanagement/commission/commission'),
      //     name: '提成管理',
      //     meta: {
      //         name: '提成管理新增'
      //     }
      // },
      // {
      //     id: '1001',
      //     path: '/financialmanagement/commission/addCommission/:id',
      //     component: () =>
      //         import ('@/page/financialmanagement/commission/addCommission'),
      //     name: '提成管理新增',
      //     hidden: true,
      //     meta: {
      //         hidden: true
      //     }
      // },
      /**------------------------------------ */
      {
        id: '1003',
        path: '/financialmanagement/weeka/Addweeklist/:id',
        component: () => import('@/page/financialmanagement/weeka/Addweeklist'),
        name: '周名单导入新增',
        hidden: true,
        meta: {
          hidden: true,
          keepAlive: false,
          id: '1003',
        },
      },
      /**------------------------------------ */
      {
        id: '1300',
        path: '/WinningRecord/WinningRecord',
        component: () => import('@/page/WinningRecord/WinningRecord'),
        name: '中奖记录',
        meta: {
          name: '中奖记录',
          keepAlive: true,
          showOperaManual: true,
          id: '1300',
        },
      },
      {
        id: '1041',
        path: '/financialmanagement/OfflineBorrowingManagement',
        name: '线下借支管理',
        component: () => import('@/page/weeka'),
        children: [
          {
            id: '1051',
            path: '/financialmanagement/OfflineBorrowingManagement/OfflineBorrowingManagementList',
            component: () => import('@/page/financialmanagement/OfflineBorrowingManagement/OfflineBorrowingManagementList'),
            name: '线下借支总表',
            meta: {
              showOperaManual: true,
              name: '线下借支总表',
              keepAlive: true,
              id: '1051',
            },
          },
           {
            id: '1052',
            path: '/financialmanagement/OfflineBorrowingManagement/FinancialApprovalFormList',
            component: () => import('@/page/financialmanagement/OfflineBorrowingManagement/FinancialApprovalForm/FinancialApprovalFormList'),
            name: '财务审批单',
            meta: {
              showOperaManual: true,
              name: '财务审批单',
              keepAlive: true,
              id: '1052',
            },
          },
           {
            id: '1053',
            path: '/financialmanagement/OfflineBorrowingManagement/FinancialApprovalFormDetails/:strItems',
            component: () => import('@/page/financialmanagement/OfflineBorrowingManagement/FinancialApprovalForm/FinancialApprovalFormDetails'),
            name: '财务审批单详情',
            meta: {
              showOperaManual: true,
              name: '财务审批单详情',
              keepAlive: true,
              id: '1053',
            },
          },
          
        ]
      },
      {
        id: '104',
        path: '/financialmanagement/weeka',
        name: '周薪管理',
        component: () => import('@/page/weeka'),
        children: [
          {
            id: '105',
            path: '/financialmanagement/weeka/Weeklist',
            component: () => import('@/page/financialmanagement/weeka/Weeklist'),
            name: '周薪名单导入',
            meta: {
              showOperaManual: true,
              name: '周薪名单导入新增',
              keepAlive: true,
              id: '105',
            },
          },
          {
            id: '106',
            path: '/financialmanagement/weeka/Payroll',
            component: () => import('@/page/financialmanagement/weeka/Payroll'),
            name: '简化版周薪导入',
            meta: {
              showOperaManual: true,
              keepAlive: true,
              id: '106',
            },
          },
          {
            id: '1060',
            path: '/financialmanagement/weeklyPay/weeklyPayList',
            component: () =>
              import('@/page/financialmanagement/weeklyPay/weeklyPayList'),
            name: '周薪预支',
            meta: {
              showOperaManual: true,
              name: '周薪预支',
              keepAlive: true,
              id: '1060'
            }
          },
          {
            id: '1120',
            path: '/financialmanagement/weeklyPay/weeklyPayListDetails/:strItems',
            component: () =>
                import('@/page/financialmanagement/weeklyPay/weeklyPayListDetails'),
            name: '周薪预支明细',
            hidden: true,
            meta: {
                hidden: true,
                keepAlive: false,
                id: '1120'
            }
          },
          {
            id: '10600',
            path: '/financialmanagement/weeklyPay/weeklyPaySalaryList',
            component: () =>
              import('@/page/financialmanagement/weeklyPay/weeklyPaySalaryList'),
            name: '周薪预支总表',
            meta: {
              showOperaManual: true,
              name: '周薪预支总表',
              keepAlive: true,
              id: '10600'
            }
          },
        ],
      },
      {
        id: '107',
        path: '/financialmanagement/borrowQuit',
        name: '借支离职工资',
        component: () => import('@/page/borrowQuit/borrowQuit'),
        children: [
          {
            id: '210',
            path: '/financialmanagement/borrowQuit/payroll',
            component: () => import('@/page/financialmanagement/borrowQuit/payroll'),
            name: '借支离职工资总表',
            meta: {
              showOperaManual: true,
              keepAlive: true,
              id: '210',
            },
          },
          {
            id: '211',
            path: '/financialmanagement/borrowQuit/bupload',
            component: () => import('@/page/financialmanagement/borrowQuit/bupload'),
            name: '借支离职工资总表导出',
            meta: {
              showOperaManual: true,
              name: '借支离职工资总表导出',
              keepAlive: true,
              id: '211',
            },
          },
          {
            id: '109',
            path: '/financialmanagement/borrowQuit/flowWater',
            component: () => import('@/page/financialmanagement/borrowQuit/flowWater'),
            name: '流水导入',
            meta: {
              showOperaManual: true,
              keepAlive: true,
              id: '109',
            },
          },
        ],
      },
      {
        id: '112',
        path: '/financialmanagement/borrowQuit/addFlowWater/:id',
        component: () => import('@/page/financialmanagement/borrowQuit/addFlowWater'),
        name: '流水导入新增',
        hidden: true,
        meta: {
          hidden: true,
          keepAlive: false,
          id: '112',
        },
      },
      {
        id: '108',
        name: '内部工资条',
        path: '/financialmanagement/upwagein',
        component: () => import('@/page/upwagein/upwagein'),
        children: [
          {
            id: '1081',
            path: '/financialmanagement/upwagein/upwageinlist',
            component: () => import('@/page/financialmanagement/upwagein/upwageinlist'),
            name: '上传内部工资条',
            meta: {
              showOperaManual: true,
              keepAlive: true,
              id: '1081',
            },
          },
          {
            id: '1082',
            path: '/financialmanagement/upwagein/addupwagein',
            component: () => import('@/page/financialmanagement/upwagein/Addupwagein'),
            name: '内部工资条新增',
            hidden: true,
            meta: {
              hidden: true,
              keepAlive: false,
              id: '1082',
            },
          },
          {
            id: '1083',
            name: '查询内部工资条',
            path: '/financialmanagement/upwagein/seeupwagein',
            component: () => import('@/page/financialmanagement/upwagein/seeupwagein'),
            meta: {
              showOperaManual: true,
              keepAlive: true,
              id: '144',
            },
          },
        ],
      },
      {
        id: '1084',
        name: '外部工资条',
        path: '/financialmanagement/upwageout',
        component: () => import('@/page/upwageout/upwageout'),
        children: [
          {
            id: '1085',
            path: '/financialmanagement/upwageout/upwageoutlist',
            component: () => import('@/page/financialmanagement/upwageout/upwageoutlist'),
            name: '上传外部工资条',
            meta: {
              showOperaManual: true,
              keepAlive: true,
              id: '1085',
            },
          },
          {
            id: '1086',
            path: '/financialmanagement/upwageout/addupwageout',
            component: () => import('@/page/financialmanagement/upwageout/Addupwageout'),
            name: '外部工资条新增',
            hidden: true,
            meta: {
              hidden: true,
              keepAlive: false,
              id: '1086',
            },
          },
          {
            id: '1087',
            name: '查询外部工资条',
            path: '/financialmanagement/upwageout/seeupwageout',
            component: () => import('@/page/financialmanagement/upwageout/seeupwageout'),
            meta: {
              showOperaManual: true,
              keepAlive: true,
              id: '1087',
            },
          },
        ],
      },
      {
        id: '1088',
        name: '薪太软',
        path: '/financialmanagement/ruan',
        component: () => import('@/page/ruan'),
        children: [
          {
            id: '1089',
            path: '/financialmanagement/ruan/Ruan',
            component: () => import('@/page/financialmanagement/ruan/Ruan'),
            name: '薪太软自动拉取',
            meta: {
              showOperaManual: true,
              keepAlive: true,
              id: '1089',
            },
          },
          {
            id: '1092',
            path: '/financialmanagement/ruan/Uoloadxtr',
            component: () => import('@/page/financialmanagement/ruan/Uoloadxtr'),
            name: '薪太软手动导入',
            meta: {
              showOperaManual: true,
              keepAlive: true,
              id: '1092',
            },
          },
        ],
      },
      {
        id: '1090',
        name: '自动核算',
        path: '/financialmanagement/automatic',
        component: () => import('@/page/automatic'),
        children: [
          {
            id: '1091',
            path: '/financialmanagement/automatic/Automatics',
            component: () => import('@/page/financialmanagement/automatic/Automatics'),
            name: '自动核算列表',
            meta: {
              keepAlive: true,
              showOperaManual: true,
              id: '1091',
            },
          },
          {
            id: '1094',
            path: '/financialmanagement/automatic/addAuto',
            component: () => import('@/page/financialmanagement/automatic/addAuto'),
            name: '自动核算列表新增',
            hidden: true,
            meta: {
              hidden: true,
              keepAlive: false,
              id: '1094',
            },
          },
          {
            id: '10250109',
            path: '/automatic/statement/mapping',
            component: () => import('@/page/automatic/map/list'),
            name: '客户对账单映射',
            meta: {
              showOperaManual: true,
              keepAlive: true,
              id: '10250109',
            },
          },
          {
            id: '10250111',
            path: '/automatic/statement/mapping/add',
            component: () => import('@/page/automatic/map/add'),
            name: '客户对账单映射新增',
            meta: {
              id: '10250111',
              hidden: true,
            },
          },
          {
            id: '10250110',
            path: '/automatic/statement/uploading',
            component: () => import('@/page/automatic/upload/list'),
            name: '客户对账单上传',
            meta: {
              showOperaManual: true,
              keepAlive: true,
              id: '10250110',
            },
          },
          {
            id: '10250114',
            path: '/automatic/statement/uploading/add',
            component: () => import('@/page/automatic/upload/add'),
            name: '客户对账单上传新增',
            meta: {
              id: '10250114',
              hidden: true,
            },
          },
          {
            id: '10250112',
            path: '/automatic/statement/uploading/confirm',
            component: () => import('@/page/automatic/upload/confirm'),
            name: '客户对账单上传数据确认',
            meta: {
              id: '10250112',
              hidden: true,
            },
          },
          {
            id: '10250113',
            path: '/automatic/statement/uploading/calculate',
            component: () => import('@/page/automatic/upload/calculate'),
            name: '核算名单',
            meta: {
              id: '10250113',
              hidden: true,
            },
          },
          {
            id: '101501',
            name: '考勤月报表',
            path: '/automatic/statement/AttendanceMonthReport',
            component: () => import('@/page/automatic/attendanceMonth/AttendanceMonthReport'),
            meta: {
              keepAlive: true,
              showOperaManual: true,
              id: '101501',
            },
          },
          {
            id: '101502',
            name: '考勤月报表上传',
            path: '/automatic/statement/AddAttendanceMonthReport',
            component: () => import('@/page/automatic/attendanceMonth/AddAttendanceMonthReport'),
            hidden: true,
            meta: {
              hidden: true,
              keepAlive: false,
              id: '101502',
            },
          },
        ],
      },
      {
        id: '168',
        name: '供应商对账单',
        path: '/financialmanagement/automatic',
        component: () => import('@/page/automatic'),
        children: [
          {
            id: '169',
            path: '/financialmanagement/automatic/supplierList',
            component: () => import('@/page/financialmanagement/automatic/supplierList'),
            name: '供应商对账单列表',
            hidden: true,
            meta: {
              keepAlive: true,
              showOperaManual: true,
              name: '供应商对账单列表新增',
              id: '169',
            },
          },
          {
            id: '1691',
            path: '/financialmanagement/automatic/addSupplier',
            component: () => import('@/page/financialmanagement/automatic/addSupplier'),
            name: '对账单列表新增',
            hidden: true,
            meta: {
              keepAlive: false,
              name: '对账单列表新增',
              id: '1691',
            },
          },
          {
            id: '170',
            path: '/financialmanagement/automatic/createStatement',
            component: () => import('@/page/financialmanagement/automatic/createStatement'),
            name: '生成对账单',
            hidden: true,
            meta: {
              keepAlive: true,
              showOperaManual: true,
              name: '生成对账单',
              id: '170',
            },
          },
          {
            id: '10030',
            path: '/financialmanagement/automatic/sup_ours',
            name: '供应商转账',
            component: () => import('@/page/financialmanagement/automatic/sup_ours'),
            meta: {
              showOperaManual: true,
              id: '10030',
            },
          },
        ],
      },
      {
        id: '10250421',
        name: '伪批次凭证',
        path: '/financialmanagement/pseudoBatchVoucher',
        component: () => import('@/page/financialmanagement/pseudoBatchVoucher/pseudoBatchVoucher'),
        meta: {
          showOperaManual: true,
          keepAlive: false,
          id: '10250421',
        },
      },
    ],
  },
  {
    id: '111',
    path: '/financialmanagement/weeka/Addayroll',
    component: () => import('@/page/financialmanagement/weeka/Addayroll'),
    name: '简化版周薪导入新增',
    hidden: true,
    meta: {
      hidden: true,
      keepAlive: false,
      id: '111',
    },
  },
  {
    id: '112',
    name: '会员管理',
    icon: 'el-icon-medal',
    path: '/member',
    children: [
      /**------------------------------------ */
      {
        id: '113',
        path: '/member/Bancard',
        component: () => import('@/page/member/bancard/Bancard'),
        name: '会员银行卡档案库',
        meta: {
          showOperaManual: true,
          keepAlive: true,
          id: '113',
        },
      },
            {
        id: '113',
        path: '/member/ReceivePayment',
        component: () => import('@/page/member/ReceivePayment/ReceivePayment'),
        name: '会员收款信息库',
        meta: {
          showOperaManual: true,
          keepAlive: true,
          id: '113',
        },
      },
      {
        id: '113',
        path: '/member/AlipayFiles',
        component: () => import('@/page/member/AlipayFiles/AlipayFiles'),
        name: '会员支付宝档案库',
        meta: {
          showOperaManual: true,
          keepAlive: true,
          id: '113',
        },
      },
      {
        id: '114',
        path: '/member/Idcard',
        component: () => import('@/page/member/idcard/Idcard'),
        name: '会员身份证管理档案库',
        meta: {
          showOperaManual: true,
          keepAlive: true,
          id: '114',
        },
      },
      {
        id: '115',
        path: '/member/Workcard',
        component: () => import('@/page/member/workcard/Workcard'),
        name: '会员工牌管理',
        meta: {
          showOperaManual: true,
          keepAlive: true,
          id: '115',
        },
      },
      /**------------------------------------ */
      {
        id: '116',
        name: '会员打卡记录',
        path: '/Punchcard',
        component: () => import('@/page/punchcard/Punchcard'),
        meta: {
          showOperaManual: true,
          keepAlive: true,
          id: '116',
        },
      },
      {
        id: '10008',
        name: '繁哥会员库',
        component: () => import('@/page/member/library/library'),
        path: '/member/library',
        meta: {
          id: '10008',
          showOperaManual: true,
          keepAlive: true,
        },
      },
      {
        id: '10010',
        name: '会员信息修改',
        component: () => import('@/page/member/infoChange/infoChange'),
        path: '/member/infoChange',
        meta: {
          id: '10010',
          showOperaManual: true,
          keepAlive: true,
        },
      },
      {
        id: '10025',
        name: '会员池列表',
        component: () => import('@/page/memberPoolList/memberPoolList'),
        path: '/member/memberPoolList',
        meta: {
          id: '10025',
          showOperaManual: true,
          keepAlive: true,
        },
      },
      {
        id: '10035',
        name: '技工认证申报',
        component: () => import('@/page/artisan/artisan'),
        path: '/member/artisan',
        meta: {
          id: '10035',
          showOperaManual: true,
          keepAlive: true,
        },
      },
      {
        id: '10045',
        name: '会员信息',
        component: () => import('@/page/member/MemberInformation/MemberInformation'),
        path: '/member/MemberInformation',
        meta: {
          id: '10045',
          keepAlive: true,
        },
      },
      {
        id: '10060',
        name: '生成随机手机号',
        component: () => import('@/page/member/MemberPhonesBatch/MemberPhonesBatch'),
        path: '/member/MemberPhonesBatch',
        meta: {
          id: '10060',
          showOperaManual: true,
          keepAlive: true,
        },
      },
        {
        id: '10081',
        name: '外包人员查询',
        component: () => import('@/page/member/outsourcedPersonnelInquiry/list'),
        path: '/member/outsourcedPersonnelInquiry',
        meta: {
          id: '10081',
          showOperaManual: true,
          keepAlive: true,
        },
      },
      {
        id: '10069',
        name: '中航金蝶对照表',
        component: () => import('@/page/member/KingdeeComparison/KingdeeComparison'),
        path: '/member/KingdeeComparison',
        meta: {
          id: '10069',
          showOperaManual: true,
          keepAlive: true,
        },
      },
      {
        id: '720001',
        path: '/member/KingdeeComparison/addKingdeeComparison/:strItems',
        component: () => import('@/page/member/KingdeeComparison/addKingdeeComparison'),
        name: '中航金蝶对照表新增',
        hidden: false,
        meta: {
          hidden: false,
          keepAlive: false,
          id: '720001',
        },
      },
      {
        id: '112',
        path: '/member/factoryProfitAndLoss/addFactoryProfitAndLoss/:id',
        component: () =>import('@/page/member/KingdeeComparison/factoryProfitAndLoss/addFactoryProfitAndLoss'),
        name: '新增',
        hidden: true,
        meta: {
          hidden: true,
          keepAlive: false,
          id: '112',
        },
      },
      {
        id: '100991',
        name: '数据入口',
        path: '/member/dataEntrance',
        component: () =>import('@/page/member/KingdeeComparison/factoryProfitAndLoss/dataEntrance'),
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '100991',
        },
      },
      {
        id: '100992',
        name: '工厂损益导入',
        path: '/member/profitAndLoss/profitAndLossImport',
        component: () =>import('@/page/member/KingdeeComparison/factoryProfitAndLoss/profitAndLoss/profitAndLossImport'),
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '100992',
        },
      },
      {
        id: '100993',
        name: '工厂损益明细',
        path: '/member/profitAndLoss/profitAndLossDetailed',
        component: () =>import('@/page/member/KingdeeComparison/factoryProfitAndLoss/profitAndLoss/profitAndLossDetailed'),
        meta: {
          keepAlive: false,
          showOperaManual: true,
          id: '100993',
        },
      },
      {
        id: '100992',
        name: '工厂损益明细详情',
        path: '/member/profitAndLoss/Detailed/:strItems',
        component: () => import('@/page/member/KingdeeComparison/factoryProfitAndLoss/profitAndLoss/Detailed'),
        meta: {
          keepAlive: false,
          id: '100992',
        },
      },
      {
        id: '100994',
        name: '科目余额导入',
        path: '/member/accountBalance/accountBalanceImport',
        component: () =>import('@/page/member/KingdeeComparison/factoryProfitAndLoss/accountBalance/accountBalanceImport'),
        meta: {
          showOperaManual: true,
          keepAlive: true,
          id: '100994',
        },
      },
      {
        id: '100995',
        name: '科目余额明细',
        path: '/member/accountBalance/accountBalanceDetailed',
        component: () =>import('@/page/member/KingdeeComparison/factoryProfitAndLoss/accountBalance/accountBalanceDetailed'),
        meta: {
          showOperaManual: true,
          keepAlive: false,
          id: '100995',
        },
      },
      {
        id: '100992',
        name: '科目余额明细详情',
        path: '/member/accountBalance/Detailed/:strItems',
        component: () => import('@/page/member/KingdeeComparison/factoryProfitAndLoss/accountBalance/Detailed'),
        meta: {
          keepAlive: false,
          id: '100992',
        },
      },
      {
        id: '100996',
        name: '工厂工时导入',
        path: '/member/workingHours/workingHoursImport',
        component: () =>import('@/page/member/KingdeeComparison/factoryProfitAndLoss/workingHours/workingHoursImport'),
        meta: {
          showOperaManual: true,
          keepAlive: true,
          id: '100996',
        },
      },
      {
        id: '100997',
        name: '工厂工时明细',
        path: '/member/workingHours/workingHoursDetailed',
        component: () =>import('@/page/member/KingdeeComparison/factoryProfitAndLoss/workingHours/workingHoursDetailed'),
        meta: {
          showOperaManual: true,
          keepAlive: false,
          id: '100997',
        },
      },
      {
        id: '100992',
        name: '工厂工时明细详情',
        path: '/member/workingHours/Detailed/:strItems',
        component: () =>import('@/page/member/KingdeeComparison/factoryProfitAndLoss/workingHours/Detailed'),
        meta: {
          keepAlive: false,
          id: '100992',
        },
      },
      {
        id: '100992',
        name: '导入文件明细',
        path: '/member/Detailed/:strItems',
        component: () =>import('@/page/member/KingdeeComparison/factoryProfitAndLoss/Detailed'),
        meta: {
          keepAlive: false,
          id: '100992',
        },
      },

      {
        id: '10065',
        name: '渠道用户',
        component: () => import('@/page/member/MemberInformation/ChannelUsers'),
        path: '/member/ChannelUsers',
        meta: {
          id: '10065',
          showOperaManual: true,
          keepAlive: true,
        },
      },
      {
        id: '10055',
        path: '/member/MemberInformation/details/:strItems',
        component: () => import('@/page/member/MemberInformation/details'),
        name: '会员信息详情',
        hidden: false,
        meta: {
          hidden: false,
          keepAlive: true,
          id: '10055',
        },
      },
    ],
  },
  /**------------------------------------ */
  {
    id: '117',
    name: '我的会员信息',
    icon: 'el-icon-document-copy',
    path: '/Mymember',
    component: () => import('@/page/mymember/Mymember'),
    meta: {
      keepAlive: true,
      showOperaManual: true,
      id: '117',
    },
  },
  {
    id: '118',
    name: '订单预警',
    icon: 'el-icon-document-delete',
    path: '/Ordwaring',
    component: () => import('@/page/ordwaring/Ordwaring'),
    meta: {
      showOperaManual: true,
      keepAlive: true,
      id: '118',
    },
  },
  {
    id: '122',
    name: '供应商用户管理',
    icon: 'el-icon-notebook-2',
    path: '/Provideruse',
    meta: {
      keepAlive: true,
      showOperaManual: true,
      id: '122',
    },
    component: () => import('@/page/provideruse/Provideruse'),
  },
  {
    id: '123',
    name: '供应商用户管理新增',
    icon: 'el-icon-user',
    path: '/Addprovideruse/:strItems',
    hidden: true,
    component: () => import('@/page/provideruse/addprovideruse'),
    meta: {
      hidden: true,
      keepAlive: false,
      id: '123',
    },
  },
  {
    id: '126',
    name: '供应商输送待绑单名单',
    icon: 'el-icon-guide',
    path: '/Providerdelwait',
    meta: {
      keepAlive: true,
      showOperaManual: true,
      id: '126',
    },
    component: () => import('@/page/providerdelwait/Providerdelwait'),
  },
  {
    id: '127',
    name: '供应商输送待绑单名单新增',
    icon: 'el-icon-user',
    path: '/Addprovs',
    hidden: true,
    component: () => import('@/page/providerdelwait/Addprovs'),
    meta: {
      hidden: true,
      keepAlive: false,
      id: '127',
    },
  },
  {
    id: '128',
    name: '供应商订单管理',
    icon: 'el-icon-document-remove',
    path: '/Providerdel',
    meta: {
      keepAlive: true,
      showOperaManual: true,
      id: '128',
    },
    component: () => import('@/page/providerdel/Providerdel'),
  },
  {
    id: '129',
    name: '供应商订单管理新增',
    icon: 'el-icon-user',
    path: '/Addproviderdel/:strItems',
    hidden: true,
    component: () => import('@/page/providerdel/addproviderdel'),
    meta: {
      hidden: true,
      keepAlive: false,
      id: '129',
    },
  },
  {
    id: '100617',
    name: '供应商订单续签',
    // icon: 'el-icon-user',
    path: '/supplier/order/renew',
    // hidden: true,
    component: () => import('@/page/providerdel/orderrenew'),
    meta: {
      // hidden: true,
      showOperaManual: true,
      keepAlive: true,
      id: '100617',
    },
  },

  {
    id: '100618',
    name: '供应商订单续签新增',
    // icon: 'el-icon-user',
    path: '/supplier/addrenew/:strItems',
    // hidden: true,
    component: () => import('@/page/providerdel/addrenew'),
    meta: {
      // hidden: true,
      keepAlive: false,
      id: '100618',
    },
  },
  /**------------------------------------ */
  {
    id: '130',
    name: '周留存率',
    icon: 'el-icon-stopwatch',
    path: '/Weekon',
    component: () => import('../page/weekon/Weekon'),
  },
  {
    id: '131',
    name: '月留存率',
    icon: 'el-icon-discover',
    path: '/Monthon',
    component: () => import('../page/monthon/Monthon'),
  },
  {
    id: '132',
    name: '我的提成',
    icon: 'el-icon-coin',
    path: '/Commission',
    component: () => import('@/page/commission/Commission'),
    meta: {
      keepAlive: true,
      showOperaManual: true,
      id: '132',
    },
  },
  /**------------------------------------ */
  {
    id: '133',
    name: '到厂人员名单',
    icon: 'el-icon-pie-chart',
    path: '/Arrivestaff',
    meta: {
      keepAlive: true,
      showOperaManual: true,
      id: '133',
    },
    component: () => import('@/page/arrivestaff/Arrivestaff'),
  },
  {
    id: '171',
    name: '标签打印记录',
    icon: 'el-icon-pie-chart',
    path: '/Labelprintrecord',
    meta: {
      name: '标签打印记录',
      keepAlive: true,
      showOperaManual: true,
      id: '171',
    },
    component: () => import('@/page/arrivestaff/Labelprintrecord'),
  },
  {
    id: '134',
    name: '到厂人员名单新增',
    icon: 'el-icon-set-up',
    path: '/Addarrsta/:strItems',
    hidden: true,
    meta: {
      hidden: true,
      keepAlive: false,
      id: '134',
    },
    component: () => import('@/page/arrivestaff/Addarrsta'),
  },
  {
    id: '135',
    name: '上车人员',
    icon: 'el-icon-truck',
    path: '/Carin',
    meta: {
      name: '上车人员新增',
      keepAlive: true,
      showOperaManual: true,
      id: '135',
    },
    component: () => import('@/page/carin/Carin'),
  },
  {
    id: '10086',
    name: '未上车人员',
    icon: 'el-icon-truck',
    path: '/NotCarin',
    meta: {
      name: '上车人员新增',
      keepAlive: true,
      showOperaManual: true,
      id: '10086',
    },
    component: () => import('@/page/NotCarin/NotCarin'),
  },
  {
    id: '136',
    path: '/Addcarin/:strItems',
    component: () => import('@/page/addcarin/Addcarin'),
    name: '上车人员新增',
    hidden: true,
    meta: {
      hidden: true,
      keepAlive: false,
      id: '136',
    },
  },
  {
    id: '142',
    name: '工资条上传',
    icon: 'el-icon-takeaway-box',
    path: '/Upwage',
    meta: {
      name: '工资条上传新增',
      keepAlive: true,
      id: '142',
    },
    component: () => import('../page/upwage/Upwage'),
  },
  {
    id: '143',
    name: '工资条上传新增',
    icon: 'el-icon-postcard',
    path: '/Addupwage',
    hidden: true,
    component: () => import('../page/upwage/Addupwage'),
    meta: {
      hidden: true,
      keepAlive: false,
      id: '143',
    },
  },
  {
    id: '144',
    name: '工资条',
    icon: 'el-icon-postcard',
    path: '/Wage',
    component: () => import('../page/wage/Wage'),
    meta: {
      keepAlive: true,
      id: '144',
    },
  },
  {
    id: '145',
    name: '宿舍管理',
    icon: 'el-icon-school',
    path: '/dorm',
    children: [
      {
        id: '146',
        path: '/dorm/Dormlist',
        component: () => import('../page/dorm/Dormlist/dormlist'),
        name: '宿舍列表',
        meta: {
          showOperaManual: true,
          keepAlive: true,
          id: '146',
        },
      },
      {
        id: '147',
        path: '/dorm/Dormlog',
        component: () => import('../page/dorm/Dormlog/dormlog'),
        name: '住舍记录',
        meta: {
          showOperaManual: true,
          keepAlive: true,
          id: '147',
        },
      },
      {
        id: '147',
        path: '/dorm/Dormlogobj',
        component: () => import('../page/dorm/Dormlog/dormlogobj'),
        name: '办理住宿',
        meta: {
          showOperaManual: true,
          keepAlive: true,
          id: '147',
        },
      },
      {
        id: '148',
        path: '/dorm/Dormlogobjs',
        component: () => import('../page/dorm/Dormlog/dormlogobjs'),
        name: '办理退宿',
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '148',
        },
      },
      {
        id: '149',
        path: '/dorm/Dormloghand',
        component: () => import('../page/dorm/Dormlog/dormloghand'),
        name: '手动办理住宿',
        meta: {
          showOperaManual: true,
          keepAlive: true,
          id: '149',
        },
      },
    ],
  },
  {
    id: '151',
    name: '标签打印',
    icon: 'el-icon-printer',
    path: '/printer',
    children: [
      /**------------------------------------ */
      {
        id: '152',
        path: '/printer/Printerlist',
        component: () => import('../page/printer/printerlist/Printerlist'),
        name: '标签打印机列表',
        meta: {
          showOperaManual: true,
          name: '标签打印机列表新增',
          keepAlive: true,
          id: '152',
        },
      },
      {
        id: '153',
        name: '标签打印机列表新增',
        icon: 'el-icon-user',
        path: '/printer/Addprinterlist/:strItems',
        hidden: true,
        meta: {
          hidden: true,
          keepAlive: false,
          id: '153',
        },
        component: () => import('@/page/printer/printerlist/Addprinterlist'),
      },
      /**------------------------------------ */
      {
        id: '154',
        path: '/printer/Printerhtml',
        component: () => import('@/page/printer/printerhtml/Printerhtml'),
        name: '打印页面',
        meta: {
          showOperaManual: true,
          keepAlive: true,
          id: '154',
        },
      },
      {
        id: '10250218',
        path: '/printer/PrinterAddress',
        component: () => import('@/page/printer/printerlist/PrinterAddress'),
        name: '打印地址',
        meta: {
          showOperaManual: true,
          keepAlive: true,
          id: '10250218',
        },
      },
      {
        id: '10250219',
        path: '/printer/AddPrinterAddress/:strItems',
        component: () => import('@/page/printer/printerlist/AddPrinterAddress'),
        name: '新增打印地址',
        meta: {
          hidden: true,
          keepAlive: false,
          id: '10250219',
        },
      },
      {
        id: '100923',
        path: '/interview/interview',
        name: '未去面试',
        component: () => import('@/page/interview/interview'),
        meta: {
          showOperaManual: true,
          keepAlive: false,
          id: '100923',
        },
      },
    ],
  },
  {
    id: '155',
    name: '用户设置',
    icon: 'el-icon-collection-tag',
    path: '/Useset',
    hidden: true,
    component: () => import('@/page/useset/Useset'),
    meta: {
      keepAlive: false,
      id: '155',
    },
  },
  {
    id: '156',
    name: '人事OA',
    icon: 'el-icon-tickets',
    path: '/personnelOA',
    children: [
      /**------------------------------------   */
      {
        id: '152',
        path: '/personnelOA/employeeContract',
        component: () => import('@/page/personnelOA/employeeContract/employeeContract'),
        name: '员工合同',
        meta: {
          id: '152',
          keepAlive: true,
          showOperaManual: true,
        },
      },
      {
        id: '1561',
        name: 'OA审批',
        path: '/personnelOA/application',
        component: () => import('@/page/application/application'),
        children: [
          {
            id: '1561',
            path: '/personnelOA/application/Entryappl',
            component: () => import('@/page/personnelOA/application/Entryappl'),
            name: '申请列表',
            meta: {
              keepAlive: true,
              showOperaManual: true,
              id: '1561',
            },
          },
          {
            id: '1567',
            path: '/personnelOA/application/Myentyylist',
            component: () => import('@/page/personnelOA/application/Myentyylist'),
            name: '待处理列表',
            meta: {
              keepAlive: true,
              showOperaManual: true,
              id: '1567',
            },
          },
          {
            id: '1568',
            path: '/personnelOA/application/Myentyylists',
            component: () => import('@/page/personnelOA/application/Myentyylists'),
            name: '已处理列表',
            meta: {
              keepAlive: true,
              showOperaManual: true,
              id: '1568',
            },
          },
          {
            id: '1562',
            path: '/personnelOA/application/addentry/:strItems',
            component: () => import('@/page/personnelOA/application/addentry'),
            name: '入职申请',
            meta: {
              keepAlive: true,
              id: '1562',
            },
          },
          {
            id: '1563',
            path: '/personnelOA/application/addleave/:strItems',
            component: () => import('@/page/personnelOA/application/addleave'),
            name: '离职申请',
            meta: {
              keepAlive: true,
              id: '1563',
            },
          },
          {
            id: '1564',
            path: '/personnelOA/application/addapply/:strItems',
            component: () => import('@/page/personnelOA/application/addapply'),
            name: '转正申请',
            meta: {
              keepAlive: true,
              id: '1564',
            },
          },
          {
            id: '1565',
            path: '/personnelOA/application/addtransfer/:strItems',
            component: () => import('@/page/personnelOA/application/addtransfer'),
            name: '调岗申请',
            meta: {
              keepAlive: true,
              id: '1565',
            },
          },
          {
            id: '1566',
            path: '/personnelOA/application/seeentry/:strItems',
            component: () => import('@/page/personnelOA/application/seeentry'),
            name: '申请详情',
            meta: {
              keepAlive: true,
              id: '1566',
              name: '申请信息',
            },
          },
          {
            id: '1566',
            path: '/personnelOA/application/seemessag/:strItems',
            component: () => import('@/page/personnelOA/application/seemessag'),
            name: '申请信息',
            hidden: true,
            meta: {
              hidden: true,
              keepAlive: true,
              id: '1566',
            },
          },
        ],
      },
    ],
  },
  {
    id: '157',
    icon: 'el-icon-money',
    path: '/tealPoint',
    children: [
      /**------------------------------------ */
      {
        id: '158',
        path: '/tealPoint/TealPoint',
        component: () => import('@/page/tealPoint/TealPoint'),
        name: '领用记录',
        meta: {
          showOperaManual: true,
          keepAlive: true,
          id: '158',
        },
      },
      {
        id: '158',
        path: '/tealPoint/UsageRecord',
        component: () => import('@/page/tealPoint/UsageRecord'),
        name: 'ClaimRecord',
        meta: {
          showOperaManual: true,
          keepAlive: true,
          id: '1580',
        },
      },
    ],
  },
  {
    id: '160',
    name: '我的会员池详情',
    icon: 'el-icon-document-copy',
    path: '/Mylistdetil/:strItems',
    component: () => import('@/page/mymemberlist/Mylistdetil'),
    meta: {
      keepAlive: true,
      id: '160',
    },
  },
  {
    id: '1693',
    name: '详情',
    icon: 'el-icon-document-copy',
    path: '/supplierDetail/:strItems',
    component: () => import('@/page/mymemberlist/supplierDetail'),
    meta: {
      keepAlive: true,
      id: '1693',
    },
  },
  {
    id: '1694',
    name: '汇总明细',
    icon: 'el-icon-document-copy',
    path: '/supplierAmtDetail/:strItems',
    component: () => import('@/page/mymemberlist/supplierAmtDetail'),
    meta: {
      keepAlive: true,
      id: '1694',
    },
  },
  {
    id: '404',
    name: '404',
    icon: '',
    path: '/404',
    hidden: true,
    meta: {
      keepAlive: false,
    },
    component: () => import('@/page/404'),
  },
  {
    id: '180',
    name: '信息列表',
    icon: '',
    path: '/myMessage',
    hidden: true,
    meta: {
      keepAlive: false,
    },
    component: () => import('@/page/mymessage/myMessage'),
  },
  {
    id: '181',
    name: '学习专区',
    icon: '',
    path: '/Study',
    hidden: true,
    meta: {
      keepAlive: false,
      showOperaManual: true,
    },
    component: () => import('@/page/study/Study'),
  },
  {
    id: '10021',
    path: '/system/exportRecordList',
    component: () => import('@/page/system/exportRecordList/exportRecordList'),
    name: '导出记录',
    meta: {
      id: '10021',
      showOperaManual: true,
      keepAlive: true,
    },
  },
  {
    id: '182',
    name: '消息管理',
    icon: '',
    path: '/Systemmessage',
    children: [
      {
        id: '183',
        path: '/Systemmessage/Systemmessage',
        component: () => import('@/page/Systemmessage/Systemmessage'),
        name: '消息发送',
        meta: {
          name: '消息管理列表新增',
          keepAlive: true,
          showOperaManual: true,
          id: '183',
        },
      },
      {
        id: '184',
        path: '/Systemmessage/addmesg',
        component: () => import('@/page/Systemmessage/addmesg'),
        name: '消息管理列表新增',
        hidden: true,
        meta: {
          hidden: true,
          keepAlive: false,
          id: '184',
        },
      },
    ],
  },
  // 用车管理
  {
    id: '165',
    name: '用车管理',
    icon: 'el-icon-document',
    path: '/vehiclemanagement',
    children: [
      {
        id: '166',
        path: '/vehiclemanagement/vehicllist/list',
        component: () => import('@/page/vehiclemanagement/vehicllist/list'),
        name: '用车列表',
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '166',
          name: '用车列表',
        },
      },
      {
        id: '15669',
        path: '/vehiclemanagement/vehicllist/ImportList',
        component: () =>
            import('@/page/vehiclemanagement/vehicllist/ImportList'),
        name: '导入',
        meta: {
            name: '导入',
            id: '15669'
        }
    },{
        id: '15668',
        path: '/vehiclemanagement/vehicllist/vehicleImport/:strItems',
        component: () =>
            import('@/page/vehiclemanagement/vehicllist/vehicleImport'),
        name: '用车人员导入',
        meta: {
            name: '用车人员导入',
            id: '15668'
        }
    },,{
        id: '15668',
        path: '/vehiclemanagement/vehicllist/vehicleImport/:strItems',
        component: () =>
            import('@/page/vehiclemanagement/vehicllist/vehicleImport'),
        name: '用车人员导入',
        meta: {
            name: '用车人员导入',
            id: '15668'
        }
    },
     {
        id: '1566',
        path: '/vehiclemanagement/vehicllist/listDetail/:strItems',
        component: () => import('@/page/vehiclemanagement/vehicllist/listDetail'),
        name: '用车详情',
        meta: {
          keepAlive: true,
          id: '1566',
          name: '用车详情',
        },
      },
      {
        id: '15661',
        path: '/vehiclemanagement/vehicllist/vehicleSwipeCard/:strItems',
        component: () => import('@/page/vehiclemanagement/vehicllist/vehicleSwipeCard'),
        name: '刷上车名单',
        meta: {
          keepAlive: true,
          id: '15661',
          name: '刷上车名单',
        },
      },
      {
        id: '1569',
        path: '/vehiclemanagement/vehicllist/departureManagement',
        component: () => import('@/page/vehiclemanagement/vehicllist/departureManagement'),
        name: '发车管理',
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '1569',
          name: '发车管理',
        },
      },
      {
        id: '1569',
        path: '/vehiclemanagement/vehicllist/departureRecord',
        component: () => import('@/page/vehiclemanagement/vehicllist/departureRecord'),
        name: '发车记录',
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '1569',
          name: '发车记录',
        },
      },
      {
        id: '1570',
        path: '/vehiclemanagement/internalVehicles/list',
        component: () => import('@/page/vehiclemanagement/internalVehicles/list'),
        name: '内部用车',
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '1570',
          name: '内部用车',
        },
      },
      {
        id: '1572',
        path: '/vehiclemanagement/internalVehicles/add/:strItems',
        component: () => import('@/page/vehiclemanagement/internalVehicles/add'),
        name: '内部用车新增',
        meta: {
          keepAlive: true,
          id: '1572',
          name: '内部用车新增',
        },
      },
      {
        id: '1661',
        path: '/vehiclemanagement/storeExpenses/list',
        component: () => import('@/page/vehiclemanagement/vehicllist/storeExpenses/list'),
        name: '门店费用列表',
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '1661',
          name: '门店费用列表',
        },
      },
      {
        id: '1663',
        path: '/vehiclemanagement/storeExpenses/detail',
        component: () => import('@/page/vehiclemanagement/vehicllist/storeExpenses/details'),
        name: '门店费用明细',
        meta: {
          showOperaManual: true,
          id: '1663',
          name: '门店费用明细',
        },
      },
      {
        id: '1662',
        path: '/vehiclemanagement/enterpriseExpenses/list',
        component: () => import('@/page/vehiclemanagement/vehicllist/enterpriseExpenses/list'),
        name: '企业费用列表',
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '1662',
          name: '企业费用列表',
        },
      },
      {
        id: '1664',
        path: '/vehiclemanagement/enterpriseExpenses/detail',
        component: () => import('@/page/vehiclemanagement/vehicllist/enterpriseExpenses/detail'),
        name: '企业费用明细',
        meta: {
          showOperaManual: true,
          id: '1664',
          name: '企业费用明细',
        },
      },
    ],
  },
  {
    id: '10921',
    name: '企业微信',
    icon: 'el-icon-document',
    children: [
      {
        id: '10922',
        name: '备忘录',
        path: '/enterpriseWechat/memoformat',
        component: () => import('@/page/enterpriseWechat/memoformat/memoformat'),
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '10922',
          name: '备忘录',
        },
      },
      {
        id: '10923',
        name: '客户联系',
        path: '/enterpriseWechat/customerConcat',
        component: () => import('@/page/enterpriseWechat/customerconcat/customerconcat'),
        meta: {
          keepAlive: true,
          id: '10923',
          name: '客户联系',
        },
      },
    ],
  },

  {
    id: '101218',
    name: '合同主体',
    icon: 'el-icon-house',
    path: '/contract/subject',
    component: () => import('@/page/contract/subject/list.vue'),
    meta: {
      id: '101218',
    },
  },

  {
    id: '101219',
    name: '模板列表',
    icon: 'el-icon-house',
    path: '/template/list',
    component: () => import('@/page/contract/template/list.vue'),
    meta: {
      id: '101219',
      showOperaManual: true,
    },
  },

  {
    id: '101220',
    name: '自定义控件',
    icon: 'el-icon-house',
    path: '/custom_control/list',
    component: () => import('@/page/contract/custom_control/list.vue'),
    meta: {
      id: '101220',
      showOperaManual: true,
    },
  },
  {
    id: '101221',
    name: '默认模板',
    icon: 'el-icon-house',
    path: '/defaultTemplate/list',
    component: () => import('@/page/contract/defaultTemplate/list.vue'),
    meta: {
      id: '101221',
      showOperaManual: true,
    },
  },
  {
    id: '101113',
    name: '工资信息收集',
    icon: 'el-icon-house',
    path: '/salary/salaryCollect',
    component: () => import('@/page/salary/salaryCollect'),
    meta: {
      showOperaManual: true,
      id: '101113',
    },
  },
  {
    id: '101114',
    name: '发票报销',
    icon: 'el-icon-house',
    path: '/bus/invoice',
    component: () => import('@/page/bus/invoice'),
    meta: {
      id: '101114',
      showOperaManual: true,
    },
  },
  {
    id: '101124',
    name: '转单记录',
    icon: 'el-icon-files',
    path: '/transfer/order',
    component: () => import('@/page/transferOrder/transferOrder'),
    meta: {
      keepAlive: true,
      showOperaManual: true,
      id: '101124',
    },
  },
  {
    id: '100102',
    name: '入职登记',
    icon: 'el-icon-files',
    path: '/enrollment/registration',
    component: () => import('@/page/enrollment/list'),
  },
  {
    id: '100102',
    name: '入职登记详情',
    icon: 'el-icon-files',
    path: '/enrollment/detail',
    component: () => import('@/page/enrollment/detail'),
  },
  {
    id: '102222',
    name: '测试',
    path: '/test',
    component: () => import('@/page/test/test'),
  },
  {
    id: '102301',
    name: '候选人线索包',
    path: '/recruitment/cluePackage/:strItems',
    component: () => import('@/page/recruitment/cluePackage/CluePackage'),
  },
  {
    id: '102302',
    name: 'AI线索',
    path: '/recruitment/cluePackageList',
    component: () => import('@/page/recruitment/cluePackage/cluePackageList'),
     meta: {
          id: '102302',
          showOperaManual: true,
          keepAlive: true,
        },
  },
  {
    id: '100417',
    name: '会员体系管理',
    children: [
      {
        id: '100418',
        name: '积分记录',
        path: '/member_system/intergal_record',
        component: () => import('@/page/member_system/intergal_record'),
        meta: {
          id: '100418',
          showOperaManual: true,
          keepAlive: true,
          name: '积分记录',
        },
      },

      {
        id: '100419',
        name: '熊币记录',
        path: '/member_system/bear_coin',
        component: () => import('@/page/member_system/bear_coin'),
        meta: {
          id: '100419',
          keepAlive: true,
          showOperaManual: true,
          name: '熊币记录',
        },
      },

      {
        id: '100420',
        name: '等级配置',
        path: '/member_system/class_config',
        component: () => import('@/page/member_system/class_config'),
        meta: {
          id: '100420',
          keepAlive: true,
          showOperaManual: true,
          name: '等级配置',
        },
      },
      {
        id: '100421',
        name: '任务配置',
        path: '/member_system/active_config',
        component: () => import('@/page/member_system/active_config'),
        meta: {
          id: '100421',
          keepAlive: true,
          showOperaManual: true,
          name: '任务配置',
        },
      },
    ],
  },
  {
    id: '100531',
    name: '航融菜单',
    path: '/hangrong/menu',
    component: () => import('@/page/hangrong/menu/Menu'),
    meta: {
      showOperaManual: true,
    },
    // children: [
    //     {
    //         id: '100533',
    //         path: '/hangrong/addMenus/:strItems',
    //         component: () => import('@/page/hangrong/menu/addMenus'),
    //         name: '航融菜单新增',
    //         meta: {
    //             keepAlive: false,
    //             id: '100533'
    //         }
    //     },
    // ]
  },
  {
    id: '100533',
    path: '/hangrong/addMenus/:strItems',
    component: () => import('@/page/hangrong/menu/addMenus'),
    name: '航融菜单新增',
    meta: {
      keepAlive: false,
      id: '100533',
    },
  },
  {
    id: '100532',
    name: '航融权限',
    path: '/hangrong/permission',
    component: () => import('@/page/hangrong/permission/Author'),
    meta: {
      showOperaManual: true,
    },
    // children: [
    //     {
    //         id: '100534',
    //         path: '/hangrong/addAuthors/:strItems',
    //         component: () => import('@/page/hangrong/permission/addAuthors'),
    //         name: '航融权限新增',
    //         meta: {
    //             keepAlive: false,
    //             id: '100534'
    //         }
    //     },
    // ]
  },
  {
    id: '100534',
    path: '/hangrong/addAuthors/:strItems',
    component: () => import('@/page/hangrong/permission/addAuthors'),
    name: '航融权限新增',
    meta: {
      keepAlive: false,
      id: '100534',
    },
  },
  {
    id: '100535',
    path: '/hangrong/enterprise',
    component: () => import('@/page/hangrong/enterprise/enterpriseList.vue'),
    name: '航融公司项目概览',
    meta: {
      keepAlive: false,
      showOperaManual: true,
      id: '100535',
    },
  },
  {
    id: '100535',
    path: '/hangrong/app',
    component: () => import('@/page/hangrong/app/appList.vue'),
    name: '航融应用管理',
    meta: {
      keepAlive: false,
      showOperaManual: true,
      id: '100535',
    },
  },
  {
    id: '100536',
    path: '/hangrong/user',
    component: () => import('@/page/hangrong/user/user.vue'),
    name: '航融用户管理',
    meta: {
      keepAlive: false,
      showOperaManual: true,
      id: '100536',
    },
  },
  {
    id: '100599',
    path: '/hangrong/accountOnline',
    component: () => import('@/page/hangrong/accountOnline/accountOnline.vue'),
    name: '在线开户',
    meta: {
      keepAlive: true,
      showOperaManual: true,
      id: '100599',
    },
  },
  {
    id: '100588',
    path: '/hangrong/accountOnlineDetaisl/:strItems',
    component: () => import('@/page/hangrong/accountOnline/accountOnlineDetaisl.vue'),
    name: '在线开户详情',
    meta: {
      keepAlive: false,
      showOperaManual: true,
      id: '100588',
    },
  },
  {
    id: '100588',
    path: '/hangrong/salaryList',
    component: () => import('@/page/hangrong/salaryList/salaryList.vue'),
    name: '发薪单位',
    meta: {
      keepAlive: true,
      showOperaManual: true,
      id: '100588',
    },
  },
  {
    id: '100588',
    path: '/hangrong/salaryListDetails/:strItems',
    component: () => import('@/page/hangrong/salaryList/salaryListDetails.vue'),
    name: '发薪单位详情',
    meta: {
      keepAlive: false,
      showOperaManual: true,
      id: '100588',
    },
  },
  {
    id: '1005881',
    path: '/PointsAnnouncement/PointsAnnouncement',
    component: () => import('@/page/PointsAnnouncement/PointsAnnouncement.vue'),
    name: '积分公告',
    meta: {
      keepAlive: true,
      showOperaManual: true,
      id: '1005881',
    },
  },
  {
    id: '888',
    icon: 'el-icon-mobile',
    path: '/PointsMall',
    children: [
      {
        id: '41',
        path: '/PointsMall/PointsClassification',
        component: () => import('@/page/PointsMall/PointsClassification.vue'),
        name: 'PointsClassification',
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '41',
        },
      },
      {
        id: '41',
        path: '/PointsMall/PointsBasedProducts',
        component: () => import('@/page/PointsMall/PointsBasedProducts'),
        name: '积分商品',
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '41',
        },
      },
      {
        id: '41',
        path: '/PointsMall/PointsOrderRecord',
        component: () => import('@/page/PointsMall/PointsOrderRecord'),
        name: '订单记录',
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '41',
        },
      },
      {
        id: '480',
        path: '/PointsMall/WriteOffRecords',
        component: () => import('@/page/PointsMall/WriteOffRecords'),
        name: '核销记录',
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '480',
        },
      },

      {
        id: '7200000',
        path: '/PointsMall/addPointsClassification/:strItems',
        component:
          () => import('@/page/PointsMall/addPointsClassification')
        ,
        name: '积分分类',
        meta: {
          keepAlive: false,
          id: '7200000',
        },
      },
      {
        id: '720000',
        path: '/PointsMall/addPointsBasedProducts/:strItems',
        component: () => import('@/page/PointsMall/addPointsBasedProducts'),
        name: '积分商城新增',
        hidden: false,
        meta: {
          hidden: false,
          keepAlive: false,
          id: '720000',
        },
      },
      {
        id: '7200000',
        path: '/PointsMall/addPointsClassification/:strItems',
        component: () => import('@/page/PointsMall/addPointsClassification'),
        name: '积分分类新增',
        hidden: false,
        meta: {
          hidden: false,
          keepAlive: false,
          id: '7200000',
        },
      },
      {
        id: '720000',
        path: '/PointsMall/addPointsBasedProducts/:strItems',
        component: () => import('@/page/PointsMall/addPointsBasedProducts'),
        name: '积分商城',
        hidden: false,
        meta: {
          hidden: false,
          keepAlive: false,
          id: '720000',
        },
      },
      {
        id: '7200000',
        path: '/PointsMall/addCardPassword/:strItems',
        component: () => import('@/page/PointsMall/addCardPassword'),
        name: '商品卡密',
        hidden: false,
        meta: {
          hidden: false,
          keepAlive: false,
          id: '7200000',
        },
      },
    ],
  },
  {
    id: '999',
    name: '在线考试',
    icon: 'el-icon-mobile',
    path: '/examination',
    children: [
      {
        id: '41',
        path: '/examination/QuestionClassification',
        component: () => import('@/page/examination/QuestionClassification'),
        name: '题库分类',
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '41',
        },
      },
      {
        id: '41',
        path: '/examination/QuestionList',
        component: () => import('@/page/examination/QuestionList'),
        name: '题库列表',
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '41',
        },
      },
      {
        id: '41',
        path: '/examination/RegularExamClassification',
        component: () => import('@/page/examination/RegularExamClassification'),
        name: '问卷分类',
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '41',
        },
      },
      {
        id: '7200000',
        path: '/examination/RegularExamList',
        component: () => import('@/page/examination/RegularExamList'),
        name: '问卷列表',
        hidden: false,
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '7200000',
        },
      },
      {
        id: '7200000',
        path: '/examination/QuestionListDetails/:strItems',
        component: () => import('@/page/examination/QuestionListDetails'),
        name: '查看详情',
        hidden: false,
        meta: {
          keepAlive: false,
          id: '7200000',
        },
      },
      {
        id: '7200000',
        path: '/examination/QuestionListadd/:strItems',
        component: () => import('@/page/examination/QuestionListadd'),
        name: '题库列表新增',
        hidden: true,
        meta: {
          keepAlive: false,
          id: '7200000',
        },
      },
      {
        id: '7200000',
        path: '/examination/RegularExamListadd/:strItems',
        component: () => import('@/page/examination/RegularExamListadd'),
        name: '试卷列表新增',
        hidden: true,
        meta: {
          keepAlive: false,
          id: '7200000',
        },
      },
      {
        id: '7200000',
        path: '/examination/RegularExamListDetail/:strItems',
        component: () => import('@/page/examination/RegularExamListDetail'),
        name: '试题详情',
        hidden: false,
        meta: {
          keepAlive: false,
          id: '7200000',
        },
      },
      {
        id: '7200000',
        path: '/examination/ExamRecords',
        component: () => import('@/page/examination/ExamRecords'),
        name: '考试记录',
        hidden: false,
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '7200000',
        },
      },
      {
        id: '7200000',
        path: '/ActivityList/ActivityList',
        component: () => import('@/page/ActivityList/ActivityList'),
        name: '活动名单导入',
        hidden: false,
        meta: {
          keepAlive: true,
          id: '7200000',
        },
      },
      {
        id: '7200000',
        path: '/Statistics/TurnoverRate',
        component: () => import('@/page/Statistics/TurnoverRate'),
        name: '离职率统计',
        hidden: false,
        meta: {
          showOperaManual: true,
          keepAlive: true,
          id: '7200000',
        },
      },
      {
        id: '7200000',
        path: '/boardingReward/awardRecord',
        component: () => import('@/page/boardingReward/awardRecord'),
        name: '奖励记录',
        hidden: false,
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '7200000',
        },
      },
      {
        id: '7200000',
        path: '/boardingReward/rewardPeople',
        component: () => import('@/page/boardingReward/rewardPeople'),
        name: '奖励人员',
        hidden: false,
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '7200000',
        },
      },
    ],
  },



{
    id: '9991',
    name: '心理测评管理',
    icon: 'el-icon-mobile',
    path: '/psychologicalAssessment',
    children: [
      {
        id: '411',
        path: '/psychologicalAssessment/QuestionClassification',
        component: () => import('@/page/psychologicalAssessment/QuestionClassification'),
        name: 'QuestionClassification',
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '4112',
        },
      },
      {
        id: '412',
        path: '/psychologicalAssessment/QuestionList',
        component: () => import('@/page/psychologicalAssessment/QuestionList'),
        name: 'QuestionList',
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '412',
        },
      },
      {
        id: '413',
        path: '/psychologicalAssessment/RegularExamClassification',
        component: () => import('@/page/psychologicalAssessment/RegularExamClassification'),
        name: '试卷分类',
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '413',
        },
      },
      {
        id: '72000001',
        path: '/psychologicalAssessment/RegularExamList',
        component: () => import('@/page/psychologicalAssessment/RegularExamList'),
        name: '试卷列表',
        hidden: false,
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '72000001',
        },
      },
      {
        id: '72000002',
        path: '/psychologicalAssessment/QuestionListDetails/:strItems',
        component: () => import('@/page/psychologicalAssessment/QuestionListDetails'),
        name: 'QuestionListDetails',
        hidden: false,
        meta: {
          keepAlive: false,
          id: '72000002',
        },
      },
      {
        id: '72000003',
        path: '/psychologicalAssessment/QuestionListadd/:strItems',
        component: () => import('@/page/psychologicalAssessment/QuestionListadd'),
        name: 'QuestionListadd1',
        hidden: true,
        meta: {
          keepAlive: false,
          id: '72000003',
        },
      },
      {
        id: '72000004',
        path: '/psychologicalAssessment/RegularExamListadd/:strItems',
        component: () => import('@/page/psychologicalAssessment/RegularExamListadd'),
        name: 'RegularExamListadd',
        hidden: true,
        meta: {
          keepAlive: false,
          id: '72000004',
        },
      },
      {
        id: '72000005',
        path: '/psychologicalAssessment/RegularExamListDetail/:strItems',
        component: () => import('@/page/psychologicalAssessment/RegularExamListDetail'),
        name: 'RegularExamListDetail',
        hidden: false,
        meta: {
          keepAlive: false,
          id: '72000005',
        },
      },
      {
        id: '72000006',
        path: '/psychologicalAssessment/ExamRecords',
        component: () => import('@/page/psychologicalAssessment/ExamRecords'),
        name: '测评记录',
        hidden: false,
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '72000006',
        },
      },
    ],
  },





  {
    id: '999',
    name: '财务数据管理',
    icon: 'el-icon-mobile',
    path: '/dataCenter',
    children: [
      {
        id: '100999',
        name: '工厂累积损益',
        path: '/dataCenter/factoryProfitAndLoss',
        component: () => import('@/page/dataCenter/financialManagement/factoryProfitAndLoss'),
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '100999',
        },
      },
      {
        id: '109999',
        name: '各大厂损益',
        path: '/dataCenter/majorFactoriesProfitAndLoss',
        component: () =>import('@/page/dataCenter/financialManagement/majorFactoriesProfitAndLoss'),
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '109999',
        },
      },
      {
        id: '109991',
        name: '集团累积损益',
        path: '/dataCenter/accumulatedProfitAndLoss',
        component: () => import('@/page/dataCenter/financialManagement/accumulatedProfitAndLoss'),
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '109991',
        },
      },
      {
        id: '109991',
        name: '集团损益',
        path: '/dataCenter/groupProfitAndLoss',
        component: () =>import('@/page/dataCenter/financialManagement/groupProfitAndLoss'),
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '109991',
        },
      },
        {
        id: '1009991',
        name: '收付款方',
        path: '/financialmanagement/paymentParty',
        component: () =>import('@/page/financialmanagement/transactionLedger/paymentPartyList'),
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '1009991',
        },
      },
        {
        id: '1009992',
        name: '收付款台账',
        path: '/financialmanagement/collectionPaymentLedger',
        component: () =>import('@/page/financialmanagement/transactionLedger/collectionPaymentLedger'),
        meta: {
          keepAlive: false,
          showOperaManual: true,
          id: '1009992',
        },
      },
        {
        id: '1009999',
        name: '收付款台账新增',
        path: '/financialmanagement/paymentLedgerAdd/:strItems',
        component: () =>import('@/page/financialmanagement/transactionLedger/paymentLedgerAdd'),
        meta: {
          keepAlive: false,
          showOperaManual: true,
          id: '1009999',
        },
      },
        {
        id: '1009993',
        name: '导入收付款台账',
        path: '/financialmanagement/paymentLedgerUploadFile',
        component: () =>import('@/page/financialmanagement/transactionLedger/paymentLedgerUploadFile'),
        meta: {
          keepAlive: false,
          showOperaManual: false,
          id: '1009993',
        },
      },
    ],
  },
  {
    id: '101205',
    name: '会员管理分析',
    icon: 'el-icon-pie-chart',
    path: '/member_management',
    children: [
      {
        id: '101206',
        name: '组件测试',
        path: '/componentTest',
        component: () => import('@/page/dataCenter/componentTest'),
      },
      {
        id: '101210',
        name: '会员总览',
        path: '/membershipManagementAnalysis/memberOverview',
        component: 
          () =>
            import(
              '@/page/dataCenter/membershipManagementAnalysis/memberOverview'
            )
        ,
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '101210',
        },
      },
    ],
  },
  {
    id: '10250102',
    name: '门店招聘分析',
    icon: 'el-icon-pie-chart',
    children: [
      {
        id: '10250103',
        name: '区域总览',
        path: '/dataCenter/areaOverview',
        component: () => import('@/page/dataCenter/areaOverview/areaOverview'),
        meta: {
          id: '10250103',
          showOperaManual: true,
        },
      },
      {
        id: '10250104',
        name: '门店总览',
        path: '/dataCenter/storeOverview',
        component: () => import('@/page/dataCenter/storeOverview/storeOverview'),
        meta: {
          id: '10250104',
          showOperaManual: true,
        },
      },
      {
        id: '10250320',
        name: '分组分析',
        path: '/dataCenter/groupingAnalysis',
        component: () => import('@/page/dataCenter/groupingAnalysis/groupingAnalysis'),
        meta: {
          id: '10250320',
          showOperaManual: true,
        },
      },
      {
        id: '10250321',
        name: '经纪人分析',
        path: '/dataCenter/broker',
        component: () => import('@/page/dataCenter/broker/broker'),
        meta: {
          id: '10250321',
          showOperaManual: true,
        },
      },
      {
        id: '10250322',
        name: '会员池分析',
        path: '/dataCenter/memberPool',
        component: () => import('@/page/dataCenter/memberPool/memberPool'),
        meta: {
          id: '10250322',
          showOperaManual: true,
        },
      },
      {
        id: '10250323',
        name: '报名分析',
        path: '/dataCenter/signUp',
        component: () => import('@/page/dataCenter/signUp/signUp'),
        meta: {
          id: '10250323',
          showOperaManual: true,
        },
      },
      {
        id: '10250324',
        name: '留资分配',
        path: '/dataCenter/allocationFunds',
        component: () => import('@/page/dataCenter/allocationFunds/allocationFunds'),
        meta: {
          id: '10250324',
          showOperaManual: true,
          keepAlive: true,
        },
      },
      {
        id: '10250325',
        path: '/dataCenter/addallocationFunds/:strItems',
        component: () => import('@/page/dataCenter/allocationFunds/addallocationFunds'),
        name: '分组新增',
        hidden: true,
        meta: {
          hidden: true,
          keepAlive: false,
          id: '10250325',
        },
      },
    ],
  },
  {
    id: '10260120',
    name: '工伤应急处置中心',
    icon: 'el-icon-pie-chart',
    children: [
      {
        id: '10260121',
        name: '工伤应急处置中心',
        path: '/injuryRecord/emergency',
        component: () => import('@/page/processingCenter/injuryRecord/emergency'),
        meta: {
          id: '10260121',
          showOperaManual: true,
        },
      },
      {
        id: '10260123',
        name: '工伤应急处置中心新增',
        path: '/injuryRecord/emergency/add/:id',
        component: () => import('@/page/processingCenter/injuryRecord/emergencyAdd'),
        meta: {
          id: '10260123',
          showOperaManual: true,
        },
      },
      {
        id: '10260122',
        name: '劳动争议调解中心',
        path: '/laborDispute/mediation',
        component: () => import('@/page/processingCenter/laborDispute/mediation'),
        meta: {
          id: '10260122',
          showOperaManual: true,
        },
      },
      {
        id: '10260124',
        name: '劳动争议调解中心新增',
        path: '/laborDispute/mediation/add/:id',
        component: () => import('@/page/processingCenter/laborDispute/mediationAdd'),
        meta: {
          id: '10260124',
          showOperaManual: true,
        },
      },
    ]
  },
  {
    id: '1001282',
    icon: 'el-icon-monitor',
    children: [
       {
        id: '1001290',
        name: '资产地址',
        component: () => import('@/page/assetManagement/assetModule/assetPrintingAddress'),
        path: '/assetManagement/assetPrintingAddress',
        meta: {
          showOperaManual: true,
          id: '1001290',
          keepAlive: true,
        },
      },
           {
        id: '1001290',
        name: 'AddAssetPrintingAddress',
        component: () => import('@/page/assetManagement/assetModule/AddAssetPrintingAddress'),
        path: '/assetManagement/AddAssetPrintingAddress/:strItems',
        meta: {
          showOperaManual: true,
          id: '1001290',
        },
      },
      {
        id: '1001291',
        name: '资产清单',
        component: () => import('@/page/assetManagement/assetModule/assetInventory'),
        path: '/assetManagement/assetInventory',
        meta: {
          showOperaManual: true,
          id: '1001291',
        },
      },
      {
        id: '1001301',
        name: '资产领用',
        component: () => import('@/page/assetManagement/assetModule/assetRequisition'),
        path: '/assetManagement/assetRequisition',
        meta: {
          keepAlive: true,
          showOperaManual: true,
          id: '1001301',
        },
      },
      {
        id: '1001312',
        name: '资产退还',
        component: () => import('@/page/assetManagement/assetModule/assetReturn'),
        path: '/assetManagement/assetReturn',
        meta: {
          showOperaManual: true,
          keepAlive: true,
          id: '1001312',
        },
      },
      {
        id: '1001313',
        name: '资产处理',
        component: () => import('@/page/assetManagement/assetModule/assetDisposal'),
        path: '/assetManagement/assetDisposal',
        meta: {
          showOperaManual: true,
          keepAlive: true,
          id: '1001313',
        },
      },
      {
        id: '1001314',
        name: '耗材资料',
        component: () => import('@/page/assetManagement/consumableModule/consumablesInformation'),
        path: '/assetManagement/consumablesInformation',
        meta: {
          showOperaManual: true,
          keepAlive: true,
          id: '1001314',
        },
      },
      {
        id: '1001315',
        name: '耗材领用',
        component: () => import('@/page/assetManagement/consumableModule/consumablesRequisition'),
        path: '/assetManagement/consumablesRequisition',
        meta: {
          showOperaManual: true,
          keepAlive: true,
          id: '1001315',
        },
      },
      {
        id: '1001316',
        name: '耗材入库',
        component: () => import('@/page/assetManagement/consumableModule/consumablesWarehousing'),
        path: '/assetManagement/consumablesWarehousing',
        meta: {
          showOperaManual: true,
          keepAlive: true,
          id: '1001316',
        },
      },
      {
        id: '1001317',
        name: '耗材库存',
        component: () => import('@/page/assetManagement/consumableModule/consumablesInventory'),
        path: '/assetManagement/consumablesInventory',
        meta: {
          showOperaManual: true,
          keepAlive: true,
          id: '1001317',
        },
      },
    ],
  },
   {
         id: '7991',
        path: '/payrollManagement',
        name: '工资表管理',
        component: () => import('@/page/payrollManagement/payrollList'),
        children: [
           {
            id: '79502',
            path: '/payrollManagement/payrollList',
            component: () => import('@/page/payrollManagement/payrollList'),
            name: '工资表列表',
            meta: {
              keepAlive: true,
              showOperaManual: true,
              id: '79502',
            },
          },
           {
            id: '79503',
            path: '/payrollManagement/payrollAdd/:id',
            component: () => import('@/page/payrollManagement/payrollAdd'),
            meta: {
              keepAlive: true,
              showOperaManual: true,
              id: '79503',
            },
          },
           {
            id: '79504',
            path: '/payrollManagement/payrollDetails/:id',
            component: () => import('@/page/payrollManagement/payrollDetails'),
            meta: {
              keepAlive: true,
              showOperaManual: true,
              id: '79504',
            },
          },
           {
            id: '79505',
            path: '/payrollManagement/payrollUpdateFiles/:id',
            component: () => import('@/page/payrollManagement/payrollUpdateFiles'),
            meta: {
              keepAlive: true,
              showOperaManual: true,
              id: '79505',
            },
          },
           {
            id: '79506',
            path: '/payrollManagement/payrollAddFile/:id',
            component: () => import('@/page/payrollManagement/payrollAddFile'),
            meta: {
              keepAlive: true,
              showOperaManual: true,
              id: '79506',
            },
          },
           {
            id: '79507',
            path: '/payrollManagement/payrollUpdateFilesDetails/:id',
            component: () => import('@/page/payrollManagement/payrollUpdateFilesDetails'),
            meta: {
              keepAlive: true,
              showOperaManual: true,
              id: '79507',
            },
          },
           
          {
            id: '79571',
            path: '/payrollManagement/payrollDetailsSummary',
            component: () => import('@/page/payrollManagement/payrollDetailsSummary'),
            name: '工资表明细',
            meta: {
              // keepAlive: true,
              showOperaManual: true,
              id: '79571',
            },
          },
          {
            id: '79572',
            path: '/payrollManagement/monthlySummarySalaryTable',
            component: () => import('@/page/payrollManagement/monthlySummarySalaryTable'),
            name: '项目数据看板',
            meta: {
              // keepAlive: true,
              showOperaManual: true,
              id: '79572',
            },
          },
        ]
      },
]


function flattenRoutes(routes, parentPath = '') {
  return routes.flatMap(route => {
    // 解构路由配置项
    const { children, path, component, ...rest } = route
    
    // 计算完整路径
    let fullPath = path
    if (parentPath) {
      fullPath = path
        ? path.startsWith('/')
          ? path // 绝对路径直接使用
          : `${parentPath}/${path}`.replace(/\/+/g, '/') // 相对路径拼接
        : parentPath
    }

    // 构建当前路由对象
    const currentRoute = {
      ...rest,
      path: fullPath,
      component: component || null
    }

    // 处理异步组件格式（根据项目实际情况调整）
    if (typeof component === 'function') {
      currentRoute.component = component
    }

    // 处理子路由
    const childRoutes = children 
      ? flattenRoutes(children, fullPath)
      : []

    // 合并当前路由和子路由（如果当前路由有效）
    return [
      ...(fullPath || currentRoute.component ? [currentRoute] : []),
      ...childRoutes
    ]
  })
}


// 生成扁平化路由
const flattenedRoutes = flattenRoutes(routes)
export default  flattenedRoutes
